export const celebrityResourceBundleMock = {
  "uiContent": {
    "docTypes": [
      {
        "code": "P",
        "value": "Passport"
      },
      {
        "code": "I",
        "value": "Passport Card"
      },
      {
        "code": "L",
        "value": "Enhanced Driver's License"
      },
      {
        "code": "BT",
        "value": "Birth Certificate+State ID Card"
      },
      {
        "code": "BS",
        "value": "Birth Certificate+Student ID Card"
      },
      {
        "code": "BM",
        "value": "Birth Certificate+Military ID Card"
      },
      {
        "code": "BD",
        "value": "Birth Certificate+Driver's License"
      },
      {
        "code": "RT",
        "value": "Birth Abroad Certificate+State ID Card"
      },
      {
        "code": "RS",
        "value": "Birth Abroad Certificate+Student ID Card"
      },
      {
        "code": "RM",
        "value": "Birth Abroad Certificate+Military ID Card"
      },
      {
        "code": "RD",
        "value": "Birth Abroad Certificate+Driver's License"
      },
      {
        "code": "C",
        "value": "Naturalization Certificate"
      },
      {
        "code": "X",
        "value": "Nexus Card"
      },
      {
        "code": "E",
        "value": "Sentri Card"
      },
      {
        "code": "Z",
        "value": "Fast Card"
      },
      {
        "code": "a",
        "value": "Alien resident card"
      },
      {
        "code": "g",
        "value": "Re-Entry Document"
      },
      {
        "code": "r",
        "value": "Birth Abroad Certificate"
      },
      {
        "code": "u",
        "value": "Australian Driver's License"
      },
      {
        "code": "y",
        "value": "Refugee Travel Document"
      },
      {
        "code": "d",
        "value": "Driver's License"
      },
      {
        "code": "m",
        "value": "Military ID Card"
      },
      {
        "code": "n",
        "value": "No photo document required"
      },
      {
        "code": "s",
        "value": "Student ID Card"
      },
      {
        "code": "t",
        "value": "State ID Card"
      }
    ],
    "states": [
      {
        "code": "NA",
        "value": "Not Applicable"
      },
      {
        "code": "AL",
        "value": "Alabama"
      },
      {
        "code": "AK",
        "value": "Alaska"
      },
      {
        "code": "AB",
        "value": "Alberta"
      },
      {
        "code": "AE",
        "value": "Apo Military"
      },
      {
        "code": "AZ",
        "value": "Arizona"
      },
      {
        "code": "AR",
        "value": "Arkansas"
      },
      {
        "code": "BC",
        "value": "British Columbia"
      },
      {
        "code": "CA",
        "value": "California"
      },
      {
        "code": "CO",
        "value": "Colorado"
      },
      {
        "code": "CT",
        "value": "Connecticut"
      },
      {
        "code": "DE",
        "value": "Delaware"
      },
      {
        "code": "DC",
        "value": "District Of Columbia"
      },
      {
        "code": "FL",
        "value": "Florida"
      },
      {
        "code": "GA",
        "value": "Georgia"
      },
      {
        "code": "HI",
        "value": "Hawaii"
      },
      {
        "code": "ID",
        "value": "Idaho"
      },
      {
        "code": "IL",
        "value": "Illinois"
      },
      {
        "code": "IN",
        "value": "Indiana"
      },
      {
        "code": "IA",
        "value": "Iowa"
      },
      {
        "code": "KS",
        "value": "Kansas"
      },
      {
        "code": "KY",
        "value": "Kentucky"
      },
      {
        "code": "LA",
        "value": "Louisiana"
      },
      {
        "code": "ME",
        "value": "Maine"
      },
      {
        "code": "MB",
        "value": "Manitoba"
      },
      {
        "code": "MD",
        "value": "Maryland"
      },
      {
        "code": "MA",
        "value": "Massachusetts"
      },
      {
        "code": "MI",
        "value": "Michigan"
      },
      {
        "code": "MN",
        "value": "Minnesota"
      },
      {
        "code": "MS",
        "value": "Mississippi"
      },
      {
        "code": "MO",
        "value": "Missouri"
      },
      {
        "code": "MT",
        "value": "Montana"
      },
      {
        "code": "NE",
        "value": "Nebraska"
      },
      {
        "code": "NV",
        "value": "Nevada"
      },
      {
        "code": "NB",
        "value": "New Brunswick"
      },
      {
        "code": "NH",
        "value": "New Hampshire"
      },
      {
        "code": "NJ",
        "value": "New Jersey"
      },
      {
        "code": "NM",
        "value": "New Mexico"
      },
      {
        "code": "NY",
        "value": "New York"
      },
      {
        "code": "NL",
        "value": "Newfoundland And Labrador"
      },
      {
        "code": "NC",
        "value": "North Carolina"
      },
      {
        "code": "ND",
        "value": "North Dakota"
      },
      {
        "code": "NT",
        "value": "Northwest Territories"
      },
      {
        "code": "NS",
        "value": "Nova Scotia"
      },
      {
        "code": "NU",
        "value": "Nunavut"
      },
      {
        "code": "OH",
        "value": "Ohio"
      },
      {
        "code": "OK",
        "value": "Oklahoma"
      },
      {
        "code": "ON",
        "value": "Ontario"
      },
      {
        "code": "OR",
        "value": "Oregon"
      },
      {
        "code": "PA",
        "value": "Pennsylvania"
      },
      {
        "code": "PE",
        "value": "Prince Edward Island"
      },
      {
        "code": "PR",
        "value": "Puerto Rico"
      },
      {
        "code": "QC",
        "value": "Quebec"
      },
      {
        "code": "RH",
        "value": "Rhode Island"
      },
      {
        "code": "SK",
        "value": "Saskatchewan"
      },
      {
        "code": "SC",
        "value": "South Carolina"
      },
      {
        "code": "SD",
        "value": "South Dakota"
      },
      {
        "code": "TN",
        "value": "Tennessee"
      },
      {
        "code": "TX",
        "value": "Texas"
      },
      {
        "code": "UT",
        "value": "Utah"
      },
      {
        "code": "VT",
        "value": "Vermont"
      },
      {
        "code": "VA",
        "value": "Virginia"
      },
      {
        "code": "WA",
        "value": "Washington"
      },
      {
        "code": "WV",
        "value": "West Virginia"
      },
      {
        "code": "WI",
        "value": "Wisconsin"
      },
      {
        "code": "WY",
        "value": "Wyoming"
      },
      {
        "code": "YT",
        "value": "Yukon Territories"
      }
    ],
    "countries": [
      {
        "code": "AFG",
        "value": "Afghanistan"
      },
      {
        "code": "ALB",
        "value": "Albania"
      },
      {
        "code": "DZA",
        "value": "Algeria"
      },
      {
        "code": "ASM",
        "value": "American Samoa"
      },
      {
        "code": "AND",
        "value": "Andorra"
      },
      {
        "code": "AGO",
        "value": "Angola"
      },
      {
        "code": "AIA",
        "value": "Anguilla"
      },
      {
        "code": "ATA",
        "value": "Antarctica"
      },
      {
        "code": "ATG",
        "value": "Antigua And Barbuda"
      },
      {
        "code": "ARG",
        "value": "Argentina"
      },
      {
        "code": "ARM",
        "value": "Armenia"
      },
      {
        "code": "ABW",
        "value": "Aruba"
      },
      {
        "code": "AUS",
        "value": "Australia"
      },
      {
        "code": "AUT",
        "value": "Austria"
      },
      {
        "code": "AZE",
        "value": "Azerbaijan"
      },
      {
        "code": "BHS",
        "value": "Bahamas"
      },
      {
        "code": "BHR",
        "value": "Bahrain"
      },
      {
        "code": "BGD",
        "value": "Bangladesh"
      },
      {
        "code": "BRB",
        "value": "Barbados"
      },
      {
        "code": "BLR",
        "value": "Belarus"
      },
      {
        "code": "BEL",
        "value": "Belgium"
      },
      {
        "code": "BLZ",
        "value": "Belize"
      },
      {
        "code": "BEN",
        "value": "Benin"
      },
      {
        "code": "BMU",
        "value": "Bermuda"
      },
      {
        "code": "BTN",
        "value": "Bhutan"
      },
      {
        "code": "BOL",
        "value": "Bolivia"
      },
      {
        "code": "BON",
        "value": "Bonaire"
      },
      {
        "code": "BIH",
        "value": "Bosnia And Herzegovina  "
      },
      {
        "code": "BWA",
        "value": "Botswana"
      },
      {
        "code": "BVT",
        "value": "Bouvet Island"
      },
      {
        "code": "BRA",
        "value": "Brazil"
      },
      {
        "code": "IOT",
        "value": "British Indian Ocean"
      },
      {
        "code": "BRN",
        "value": "Brunei Darussalam"
      },
      {
        "code": "BGR",
        "value": "Bulgaria"
      },
      {
        "code": "BFA",
        "value": "Burkina Faso"
      },
      {
        "code": "BUR",
        "value": "Burma"
      },
      {
        "code": "BDI",
        "value": "Burundi"
      },
      {
        "code": "KHM",
        "value": "Cambodia"
      },
      {
        "code": "CMR",
        "value": "Cameroon"
      },
      {
        "code": "CAN",
        "value": "Canada"
      },
      {
        "code": "CPV",
        "value": "Cape Verde Islands"
      },
      {
        "code": "CYM",
        "value": "Cayman Islands"
      },
      {
        "code": "CAF",
        "value": "Central African Republic"
      },
      {
        "code": "TCD",
        "value": "Chad Republic"
      },
      {
        "code": "CHL",
        "value": "Chile"
      },
      {
        "code": "CHN",
        "value": "China"
      },
      {
        "code": "CXR",
        "value": "Christmas Island"
      },
      {
        "code": "CCK",
        "value": "Cocos Keeling Island"
      },
      {
        "code": "COL",
        "value": "Colombia"
      },
      {
        "code": "COM",
        "value": "Comoros"
      },
      {
        "code": "COK",
        "value": "Cook Islands"
      },
      {
        "code": "CRI",
        "value": "Costa Rica"
      },
      {
        "code": "CIV",
        "value": "Cote Divoire"
      },
      {
        "code": "HRV",
        "value": "Croatia"
      },
      {
        "code": "CUB",
        "value": "Cuba"
      },
      {
        "code": "CUR",
        "value": "Curacao"
      },
      {
        "code": "CYP",
        "value": "Cyprus"
      },
      {
        "code": "CZE",
        "value": "Czech Republic"
      },
      {
        "code": "DNK",
        "value": "Denmark"
      },
      {
        "code": "DJI",
        "value": "Djibouti"
      },
      {
        "code": "DMA",
        "value": "Dominica"
      },
      {
        "code": "DOM",
        "value": "Dominican Republic"
      },
      {
        "code": "UAE",
        "value": "Dubai"
      },
      {
        "code": "TMP",
        "value": "East Timor"
      },
      {
        "code": "ECU",
        "value": "Ecuador"
      },
      {
        "code": "EGY",
        "value": "Egypt"
      },
      {
        "code": "SLV",
        "value": "El Salvado"
      },
      {
        "code": "GNQ",
        "value": "Equatorial Guinea"
      },
      {
        "code": "ERI",
        "value": "Eritrea"
      },
      {
        "code": "EST",
        "value": "Estonia"
      },
      {
        "code": "ETH",
        "value": "Ethiopia"
      },
      {
        "code": "FRO",
        "value": "Faeroe Islands"
      },
      {
        "code": "FLK",
        "value": "Falkland Islands"
      },
      {
        "code": "FJI",
        "value": "Fiji Islands"
      },
      {
        "code": "FIN",
        "value": "Finland"
      },
      {
        "code": "FRA",
        "value": "France"
      },
      {
        "code": "GUF",
        "value": "French Guiana"
      },
      {
        "code": "PYF",
        "value": "French Polynesia"
      },
      {
        "code": "ATF",
        "value": "French South Territories"
      },
      {
        "code": "GAB",
        "value": "Gabon"
      },
      {
        "code": "GMB",
        "value": "Gambia"
      },
      {
        "code": "GEO",
        "value": "Georgia"
      },
      {
        "code": "DEU",
        "value": "Germany"
      },
      {
        "code": "GHA",
        "value": "Ghana"
      },
      {
        "code": "GIB",
        "value": "Gibraltar"
      },
      {
        "code": "GRC",
        "value": "Greece"
      },
      {
        "code": "GRL",
        "value": "Greenland"
      },
      {
        "code": "GRD",
        "value": "Grenada"
      },
      {
        "code": "GLP",
        "value": "Guadeloupe"
      },
      {
        "code": "GUM",
        "value": "Guam"
      },
      {
        "code": "GTM",
        "value": "Guatemala"
      },
      {
        "code": "GIN",
        "value": "Guinea"
      },
      {
        "code": "GNB",
        "value": "Guinea-Bissau"
      },
      {
        "code": "GUY",
        "value": "Guyana"
      },
      {
        "code": "HTI",
        "value": "Haiti"
      },
      {
        "code": "HMD",
        "value": "Heard and Mcdonald Island"
      },
      {
        "code": "HND",
        "value": "Honduras"
      },
      {
        "code": "HKG",
        "value": "Hong Kong"
      },
      {
        "code": "HUN",
        "value": "Hungary"
      },
      {
        "code": "ISL",
        "value": "Iceland"
      },
      {
        "code": "IND",
        "value": "India"
      },
      {
        "code": "IDN",
        "value": "Indonesia"
      },
      {
        "code": "IRN",
        "value": "Iran"
      },
      {
        "code": "IRQ",
        "value": "Iraq"
      },
      {
        "code": "IRL",
        "value": "Ireland"
      },
      {
        "code": "ISR",
        "value": "Israel"
      },
      {
        "code": "ITA",
        "value": "Italy"
      },
      {
        "code": "JAM",
        "value": "Jamaica"
      },
      {
        "code": "JPN",
        "value": "Japan"
      },
      {
        "code": "JOR",
        "value": "Jordan"
      },
      {
        "code": "KAZ",
        "value": "Kazakhstan"
      },
      {
        "code": "KEN",
        "value": "Kenya"
      },
      {
        "code": "KIR",
        "value": "Kiribati"
      },
      {
        "code": "KWT",
        "value": "Kuwait"
      },
      {
        "code": "KGZ",
        "value": "Kyrgyzstan"
      },
      {
        "code": "LAO",
        "value": "Laos"
      },
      {
        "code": "LVA",
        "value": "Latvia"
      },
      {
        "code": "LBN",
        "value": "Lebanon"
      },
      {
        "code": "LSO",
        "value": "Lesotho"
      },
      {
        "code": "LBR",
        "value": "Liberia"
      },
      {
        "code": "LBY",
        "value": "Libya"
      },
      {
        "code": "LIE",
        "value": "Liechtenstein"
      },
      {
        "code": "LTU",
        "value": "Lithuania"
      },
      {
        "code": "LUX",
        "value": "Luxembourg"
      },
      {
        "code": "MAC",
        "value": "Macao"
      },
      {
        "code": "MCD",
        "value": "Macedonia"
      },
      {
        "code": "MDG",
        "value": "Madagascar"
      },
      {
        "code": "MWI",
        "value": "Malawi"
      },
      {
        "code": "MYS",
        "value": "Malaysia"
      },
      {
        "code": "MDV",
        "value": "Maldives"
      },
      {
        "code": "MLI",
        "value": "Mali Republic"
      },
      {
        "code": "MLT",
        "value": "Malta"
      },
      {
        "code": "MHL",
        "value": "Marshall Islands"
      },
      {
        "code": "MTO",
        "value": "Martinique"
      },
      {
        "code": "MRT",
        "value": "Mauritania"
      },
      {
        "code": "MUS",
        "value": "Mauritius"
      },
      {
        "code": "MYT",
        "value": "Mayotte Island"
      },
      {
        "code": "FXX",
        "value": "Metropolitan France"
      },
      {
        "code": "MEX",
        "value": "Mexico"
      },
      {
        "code": "FSM",
        "value": "Micronesia"
      },
      {
        "code": "MDA",
        "value": "Moldova"
      },
      {
        "code": "MCO",
        "value": "Monaco"
      },
      {
        "code": "MNG",
        "value": "Mongolian Peoples Republic"
      },
      {
        "code": "MNE",
        "value": "Montenegro"
      },
      {
        "code": "MSR",
        "value": "Montserrat"
      },
      {
        "code": "MAR",
        "value": "Morocco"
      },
      {
        "code": "MOZ",
        "value": "Mozambique"
      },
      {
        "code": "MMR",
        "value": "Myanmar"
      },
      {
        "code": "NAM",
        "value": "Namibia"
      },
      {
        "code": "NRU",
        "value": "Nauru"
      },
      {
        "code": "NPL",
        "value": "Nepal"
      },
      {
        "code": "NLD",
        "value": "Netherlands"
      },
      {
        "code": "ANT",
        "value": "Netherlands Antillesnes"
      },
      {
        "code": "NCL",
        "value": "New Caledonia"
      },
      {
        "code": "NZL",
        "value": "New Zealand"
      },
      {
        "code": "NIC",
        "value": "Nicaragua"
      },
      {
        "code": "NGA",
        "value": "Nigeria"
      },
      {
        "code": "NIU",
        "value": "Niue"
      },
      {
        "code": "NFK",
        "value": "Norfolk Island"
      },
      {
        "code": "PRK",
        "value": "North Korea"
      },
      {
        "code": "MNP",
        "value": "Northern Mariana Island"
      },
      {
        "code": "NOR",
        "value": "Norway"
      },
      {
        "code": "OMN",
        "value": "Oman"
      },
      {
        "code": "OTH",
        "value": "Other"
      },
      {
        "code": "PAK",
        "value": "Pakistan"
      },
      {
        "code": "PLW",
        "value": "Palau"
      },
      {
        "code": "PSE",
        "value": "Palestine"
      },
      {
        "code": "PAN",
        "value": "Panama"
      },
      {
        "code": "PNG",
        "value": "Papua New Guinea"
      },
      {
        "code": "PRY",
        "value": "Paraguay"
      },
      {
        "code": "PER",
        "value": "Peru"
      },
      {
        "code": "PHL",
        "value": "Philippines"
      },
      {
        "code": "PCN",
        "value": "Pitcairn"
      },
      {
        "code": "POL",
        "value": "Poland"
      },
      {
        "code": "PRT",
        "value": "Portugal"
      },
      {
        "code": "QAT",
        "value": "Qatar"
      },
      {
        "code": "COG",
        "value": "Republic Of Congo"
      },
      {
        "code": "YMD",
        "value": "Republic of Yemen"
      },
      {
        "code": "REU",
        "value": "Reunion Island"
      },
      {
        "code": "ROM",
        "value": "Romania"
      },
      {
        "code": "RUE",
        "value": "Russia"
      },
      {
        "code": "RWA",
        "value": "Rwanda"
      },
      {
        "code": "SGS",
        "value": "S.Georgia and Sandwich Isla"
      },
      {
        "code": "SHN",
        "value": "Saint Helena"
      },
      {
        "code": "KNA",
        "value": "Saint Kitts and Nevls"
      },
      {
        "code": "LCA",
        "value": "Saint Lucia"
      },
      {
        "code": "SPM",
        "value": "Saint Pierre and Miquelon"
      },
      {
        "code": "WSM",
        "value": "Samoa (Western Ind)"
      },
      {
        "code": "SMR",
        "value": "San Marino"
      },
      {
        "code": "STP",
        "value": "Sao Tome And Principe"
      },
      {
        "code": "SAU",
        "value": "Saudi Arabia"
      },
      {
        "code": "SEN",
        "value": "Senegal Republic"
      },
      {
        "code": "SRB",
        "value": "Serbia"
      },
      {
        "code": "SYC",
        "value": "Seychelles Islands"
      },
      {
        "code": "SLE",
        "value": "Sierra Leone"
      },
      {
        "code": "SGP",
        "value": "Singapore"
      },
      {
        "code": "SXM",
        "value": "Sint Maarten"
      },
      {
        "code": "SVK",
        "value": "Slovakia"
      },
      {
        "code": "SVN",
        "value": "Slovenia"
      },
      {
        "code": "SLB",
        "value": "Solomon Islands"
      },
      {
        "code": "SOM",
        "value": "Somalia"
      },
      {
        "code": "ZAF",
        "value": "South Africa"
      },
      {
        "code": "KOR",
        "value": "South Korea"
      },
      {
        "code": "ESP",
        "value": "Spain"
      },
      {
        "code": "LKA",
        "value": "Sri Lanka"
      },
      {
        "code": "VCT",
        "value": "St Vincent and Grenadines"
      },
      {
        "code": "STK",
        "value": "St. Kitts"
      },
      {
        "code": "STM",
        "value": "St. Maarten"
      },
      {
        "code": "SDN",
        "value": "Sudan"
      },
      {
        "code": "SUR",
        "value": "Suriname"
      },
      {
        "code": "SJM",
        "value": "Svalbard and Mayen I"
      },
      {
        "code": "SWZ",
        "value": "Swaziland"
      },
      {
        "code": "SWE",
        "value": "Sweden"
      },
      {
        "code": "CHS",
        "value": "Switzerland"
      },
      {
        "code": "SYR",
        "value": "Syrian Arab Republic"
      },
      {
        "code": "TWN",
        "value": "Taiwan"
      },
      {
        "code": "TJK",
        "value": "Tajikistan"
      },
      {
        "code": "TZA",
        "value": "Tanzania"
      },
      {
        "code": "THA",
        "value": "Thailand"
      },
      {
        "code": "TGO",
        "value": "Togo"
      },
      {
        "code": "TKL",
        "value": "Tokelau"
      },
      {
        "code": "TON",
        "value": "Tonga Islands"
      },
      {
        "code": "TTO",
        "value": "Trinidad And Tobago"
      },
      {
        "code": "TUN",
        "value": "Tunisia"
      },
      {
        "code": "TUR",
        "value": "Turkey"
      },
      {
        "code": "TKM",
        "value": "Turkmenistan"
      },
      {
        "code": "TCA",
        "value": "Turks And Caicos Island "
      },
      {
        "code": "TUV",
        "value": "Tuvalu"
      },
      {
        "code": "UMI",
        "value": "U.S. Minor Out Island"
      },
      {
        "code": "UGA",
        "value": "Uganda"
      },
      {
        "code": "UKR",
        "value": "Ukraine"
      },
      {
        "code": "ARE",
        "value": "United Arab Emirates"
      },
      {
        "code": "GBR",
        "value": "United Kingdom"
      },
      {
        "code": "USA",
        "value": "United States"
      },
      {
        "code": "URY",
        "value": "Uruguay"
      },
      {
        "code": "UZB",
        "value": "Uzbekistan"
      },
      {
        "code": "VUT",
        "value": "Vanuatu"
      },
      {
        "code": "VAT",
        "value": "Vatican City"
      },
      {
        "code": "VEN",
        "value": "Venezuela"
      },
      {
        "code": "VNM",
        "value": "Vietnam"
      },
      {
        "code": "VGB",
        "value": "Virgin Islands (British)"
      },
      {
        "code": "VIR",
        "value": "Virgin Islands (U.S.)"
      },
      {
        "code": "WLF",
        "value": "Wallis And Futuna Islands"
      },
      {
        "code": "ESH",
        "value": "Western Sahara"
      },
      {
        "code": "YEM",
        "value": "Yemen"
      },
      {
        "code": "ZAR",
        "value": "Zaire"
      },
      {
        "code": "ZMB",
        "value": "Zambia"
      },
      {
        "code": "ZWE",
        "value": "Zimbabwe"
      }
    ]
  },
  "resourceBundle": [
    {
      "code": "label.guestinfo.loyalty.header",
      "value": "Captain's Club number (optional)"
    },
    {
      "code": "label.vaccination.reminder.takeover.headline",
      "value": "Finish check-in in the Celebrity app"
    },
    {
      "code": "label.vaccination.reminder.takeover.subcopy",
      "value": "Download the app and answer a few health questions for faster boarding."
    },
    {
      "code": "label.boardingpass.protocols.keepingyousafe",
      "value": "Keeping you safe is our top priority"
    },
    {
      "code": "label.boardingpass.protocols.healthsafety",
      "value": "Health & safety:"
    },
    {
      "code": "label.healthcenter.preparing.subcopy",
      "value": "Here's what you need to know for your upcoming cruise."
    },
    {
      "code": "label.healthcenter.preparing.header",
      "value": "Preparing for your cruise"
    },
    {
      "code": "label.healthcenter.saildates",
      "value": "Sail Dates"
    },
    {
      "code": "label.healthcenter.ship",
      "value": "Ship"
    },
    {
      "code": "label.healthcenter.healthycruising.subcopy",
      "value": "Your health and safety remain our top priority. Please review the requirements for a safe and memorable cruise vacation. Check our app for updates to these requirements as well as details for your cruise."
    },
    {
      "code": "label.healthcenter.healthycruising.header",
      "value": "Healthy Cruising"
    },
    {
      "code": "label.safety.takeover.headline",
      "value": "Be ready to board"
    },
    {
      "code": "label.safety.takeover.subcopy",
      "value": "Review our health and safety protocols."
    },
    {
      "code": "label.safety.takeover.questions",
      "value": "Questions?"
    },
    {
      "code": "label.safety.takeover.visit",
      "value": "Visit our health center"
    },
    {
      "code": "label.guestselect.safety.headline",
      "value": "Be ready to board"
    },
    {
      "code": "label.guestselect.safety.subcopy",
      "value": "Review our health and safety protocols."
    },
    {
      "code": "no.arrival.times.error.message",
      "value": "We’re not quite ready for you.  Check back closer to your cruise to select an arrival time and complete check-in."
    },
    {
      "code": "label.contracts.questions",
      "value": "Questions?"
    },
    {
      "code": "label.contracts.callus",
      "value": "Call us"
    },
    {
      "code": "label.risk.acknowledgement.title",
      "value": "Health acknowledgement"
    },
    {
      "code": "label.risk.acknowledgement.doctxt",
      "value": "HEALTH ACKNOWLEDGEMENT\n\nIMPORTANT NOTICE TO GUESTS\nEXPOSURE TO PATHOGENS (E.G., SARS-COV-2, THE VIRUS THAT CAUSES COVID-19) IS AN INHERENT RISK IN PLACES WHERE PEOPLE GATHER AND MAY RESULT IN SERIOUS ILLNESS OR DEATH. OUR HEALTH AND SAFETY MEASURES MITIGATE THIS RISK BUT DO NOT ELIMINATE IT. BEFORE BOOKING OR SAILING ON A CRUISE VACATION, GUESTS SHOULD CONSIDER THEIR INDIVIDUAL RISK LEVEL FOR EXPOSURE TO PATHOGENS AND MAKE AN INFORMED TRAVEL DECISION ON THAT BASIS. GUESTS WITH A HIGHER RISK OF SERIOUS ILLNESS MAY WISH TO CONSULT WITH THEIR PHYSICIAN PRIOR TO BOOKING OR SAILING WITH US.\nON BEHALF OF YOURSELF AND/OR OTHERS FOR WHOM YOU ARE ACTING, YOU ACKNOWLEDGE AND AGREE: (1) TO ASSUME ALL RISKS RELATED TO EXPOSURE TO PATHOGENS OR INFECTION WHILE CRUISING WITH US, INCLUDING THOSE RELATING TO GUESTS WHO ARE AT A HIGHER RISK OF SEVERE ILLNESS AS A RESULT OF THE SAME; (2) YOU HAVE REVIEWED AND WILL COMPLY WITH OUR GUEST HEALTH, SAFETY AND CONDUCT POLICY AND OUR HEALTH AND SAFETY MEASURES; AND (3) TO THE COLLECTION, USE, AND DISCLOSURE OF PERSONAL INFORMATION, INCLUDING HEALTH INFORMATION, IN CONNECTION WITH THESE MEASURES."
    },
    {
      "code": "label.risk.acknowledgement.doctxt.int",
      "value": "RISK ACKNOWLEDGMENT\n\nIMPORTANT NOTICE TO GUESTS\nEXPOSURE TO PATHOGENS (E.G., SARS-COV-2, THE VIRUS THAT CAUSES COVID-19) IS AN INHERENT RISK IN PLACES WHERE PEOPLE GATHER AND MAY RESULT IN SERIOUS ILLNESS OR DEATH. OUR HEALTH AND SAFETY MEASURES MITIGATE THIS RISK BUT DO NOT ELIMINATE IT. BEFORE BOOKING OR SAILING ON A CRUISE VACATION, GUESTS SHOULD CONSIDER THEIR INDIVIDUAL RISK LEVEL FOR EXPOSURE TO PATHOGENS AND MAKE AN INFORMED TRAVEL DECISION ON THAT BASIS. GUESTS WITH A HIGHER RISK OF SERIOUS ILLNESS MAY WISH TO CONSULT WITH THEIR PHYSICIAN PRIOR TO BOOKING OR SAILING WITH US.\nON BEHALF OF YOURSELF AND/OR OTHERS FOR WHOM YOU ARE ACTING, YOU ACKNOWLEDGE AND AGREE: (1) TO ASSUME ALL RISKS RELATED TO EXPOSURE TO PATHOGENS OR INFECTION WHILE CRUISING WITH US, INCLUDING THOSE RELATING TO GUESTS WHO ARE AT A HIGHER RISK OF SEVERE ILLNESS AS A RESULT OF THE SAME; (2) YOU HAVE REVIEWED AND WILL COMPLY WITH OUR GUEST HEALTH, SAFETY AND CONDUCT POLICY AND OUR HEALTH AND SAFETY MEASURES; AND (3) TO THE COLLECTION, USE, AND DISCLOSURE OF PERSONAL INFORMATION, INCLUDING HEALTH INFORMATION, IN CONNECTION WITH THESE MEASURES."
    },
    {
      "code": "label.contract.affirm.int.a",
      "value": "I,"
    },
    {
      "code": "label.contract.affirm.int.b",
      "value": ", have read, understand and accept the health acknowledgement. I affirm that (a) each guest whom I am checking in has also read, understand and accepts the health acknowledgement and (b) I am legally authorized to accept the health acknowledgement on behalf of each guest I am checking in."
    },
    {
      "code": "label.boarding.pass.not.cleared.to.board",
      "value": "Not yet cleared to board"
    },
    {
      "code": "label.boarding.pass.before.boarding.must",
      "value": "Before you can get on board, you must:"
    },
    {
      "code": "label.boarding.pass.answer.questions",
      "value": "Answer the health and safety questions in the app the day before your cruise."
    },
    {
      "code": "label.boarding.pass.wellness.at.terminal",
      "value": "Pass the wellness check at the terminal."
    },
    {
      "code": "label.boarding.pass.learn.more",
      "value": "Learn more"
    },
    {
      "code": "label.boarding.pass.digial.pass.ready",
      "value": "Your digital boarding passes are ready, get them in the app now"
    },
    {
      "code": "label.boarding.pass.use.the.app.a",
      "value": "Using the app will improve your experience, but if you don’t have a smartphone or cannot access the app,"
    },
    {
      "code": "label.boarding.pass.use.the.app.b",
      "value": "print this page"
    },
    {
      "code": "label.boarding.pass.use.the.app.c",
      "value": "and bring it with you to the terminal."
    },
    {
      "code": "label.boarding.pass.stay.healthy",
      "value": "We’ve kept all the fun and added a layer of safety. Follow these protocols for a healthy sailing:"
    },
    {
      "code": "label.boarding.pass.day.before.your.cruise",
      "value": "Day before your cruise:"
    },
    {
      "code": "label.boarding.pass.complete.questionnaire",
      "value": "Answer your health questions in the app"
    },
    {
      "code": "label.boarding.pass.avoid.lines",
      "value": "Save time and vacation sooner. Sign in to the app, we’ll send a reminder notification to complete the health questions. Can’t access the app? Answer your health questions at the terminal."
    },
    {
      "code": "label.boarding.pass.boarding.day",
      "value": "Boarding day:"
    },
    {
      "code": "label.boarding.pass.honor.arrival.time",
      "value": "Honor your arrival time at the terminal"
    },
    {
      "code": "label.boarding.pass.our.medical.staff.expecting",
      "value": "Everyone will receive a wellness check before being cleared to board. Guests who arrive outside of their scheduled arrival time will delay their boarding. Be sure to have your travel documents handy."
    },
    {
      "code": "label.boarding.pass.onboard",
      "value": "Onboard:"
    },
    {
      "code": "label.boarding.pass.get.connected",
      "value": "Complete your safety briefing"
    },
    {
      "code": "label.boarding.pass.the.app.helps",
      "value": "Connect to the ship’s free Wi-Fi (no internet package required, in-app charges), tap Safety on the app’s home screen to launch the safety briefing, then stop by your assembly station before the ship sails. No app? Go to your assembly station and a crew member will assist you."
    },
    {
      "code": "label.boarding.bring.boarding.documents",
      "value": "Bring boarding documents."
    },
    {
      "code": "label.boarding.bring.boarding.documents.description",
      "value": "Please carry your passport and other required documents to the terminal (do not pack them in your luggage). No photocopies or digital images are accepted."
    },
    {
      "code": "label.arrival.at.the.terminal",
      "value": "At the Terminal"
    },
    {
      "code": "label.arrival.implementing.advanced.screening.description",
      "value": "We’re doing everything we can to ensure our ships sail with healthy guests and crew by implementing wellness checks for all guests."
    },
    {
      "code": "label.arrival.make.sure.you",
      "value": "Make sure you:"
    },
    {
      "code": "label.arrival.pcr.test.results",
      "value": "Have your test results in hand:"
    },
    {
      "code": "label.arrival.pcr.test.results.description",
      "value": "We require all guests to complete SARS-CoV-2 (rtPCR) testing prior to sailing and bring the results to the pier prior to boarding. Please note the testing requirement for your sailing."
    },
    {
      "code": "label.arrival.wear.ppe",
      "value": "Wear your face covering:"
    },
    {
      "code": "label.arrival.wear.ppe.description",
      "value": "All guests are asked to wear face coverings from the time they arrive at the terminal."
    },
    {
      "code": "label.arrival.arrive.on.time",
      "value": "Arrive on time."
    },
    {
      "code": "label.arrival.arrive.on.time.content",
      "value": "Please plan to be at the terminal within your selected time or your boarding may be delayed. Print out luggage tags and attach them to your checked bags."
    },
    {
      "code": "label.arrival.arrive.on.time.description",
      "value": "Your arrival time is also when you take your pre-cruise wellness check. Please plan to get to the terminal during that time window - not before or after - so you board smoothly."
    },
    {
      "code": "label.arrival.wash.your.hands",
      "value": "Wash your hands:"
    },
    {
      "code": "label.arrival.wash.your.hands.description",
      "value": "Hand-washing stations, with soap and water, and hand sanitizing stations are readily available throughout the terminal."
    },
    {
      "code": "label.arrival.keep.your.distance",
      "value": "Keep your distance:"
    },
    {
      "code": "label.arrival.keep.your.distance.description",
      "value": "Stay at least six feet away from people outside your travel party and, if physical distancing isn’t possible, make sure your face covering covers your nose and mouth."
    },
    {
      "code": "label.contract.affirm.a",
      "value": "I,"
    },
    {
      "code": "label.contract.affirm.b",
      "value": ", have read, understand and accept the cruise ticket contract terms and the health acknowledgement.  I affirm that (a) each guest whom I am checking in has also read, understands and accepts the applicable cruise ticket terms and the health acknowledgement and (b) I am legally authorized to accept the cruise ticket contract terms and health acknowledgement on behalf of each guest I am checking in."
    },
    {
      "code": "label.arrival.required.arrival.time",
      "value": "You are required to select an arrival time for your wellness check"
    },
    {
      "code": "label.arrival.select.arrival.time",
      "value": "Please select an arrival time to check in at the terminal"
    },
    {
      "code": "label.arrival.medical.appointment",
      "value": "Your arrival time is an appointment to complete the required wellness screening prior to boarding."
    },
    {
      "code": "label.arrival.read.more",
      "value": "Read more"
    },
    {
      "code": "label.arrival.read.less",
      "value": "Read less"
    },
    {
      "code": "label.arrival.note.missing.appointment",
      "value": "Note: Arrival outside your time slot will delay your boarding."
    },
    {
      "code": "label.arrival.choose.available.slot",
      "value": "Choose from available time slots"
    },
    {
      "code": "label.arrival.available.time.slots",
      "value": "Available time slots:"
    },
    {
      "code": "label.mobile.app.download.required",
      "value": "You are required to download the mobile app prior to sailing"
    },
    {
      "code": "label.access.digital.boarding.pass",
      "value": "Access your digital boarding pass"
    },
    {
      "code": "label.answer.health.check",
      "value": "Answer the health questions on the app the day before your sailing"
    },
    {
      "code": "label.embark.safely",
      "value": "Board safely, quickly, and with confidence"
    },
    {
      "code": "label.subheader.credit.card.only",
      "value": "Guests who do not provide credit/debit card information must check in at the port."
    },
    {
      "code": "label.header.credit.card",
      "value": "Add credit/debit card"
    },
    {
      "code": "label.select.no",
      "value": "No"
    },
    {
      "code": "label.select.yes",
      "value": "Yes"
    },
    {
      "code": "label.card.save",
      "value": "Save card to quickly check in other guests."
    },
    {
      "code": "label.recent.travel",
      "value": "Your recent travel"
    },
    {
      "code": "label.card.add",
      "value": "Add card"
    },
    {
      "code": "label.card.replace",
      "value": "Save new card to quickly check in other guests (replaces current card)."
    },
    {
      "code": "label.questionnaire.q2",
      "value": "Will you have been within 6 feet of anyone who has traveled to China, Hong Kong, Macau, Iran, South Korea, or the Italian regions of Lombardy and Veneto, within 15 days of your cruise?"
    },
    {
      "code": "label.questionnaire.q1",
      "value": "Will you or anyone you’ve been in contact with have traveled from, to, or through mainland China, Hong Kong, Macau, Iran, South Korea, and/or Italy within 15 days of your cruise’s sail date?"
    },
    {
      "code": "biometrics.photo.consent.header",
      "value": "Photo consent"
    },
    null,
    {
      "code": "ssp.category",
      "value": "CATEGORY"
    },
    {
      "code": "payway.header",
      "value": "Enter your card information"
    },
    {
      "code": "payway.subheader",
      "value": "You can use the following payment methods."
    },
    {
      "code": "validation.cc.invalid.number",
      "value": "Card number specified is not supported."
    },
    {
      "code": "cc.error.message",
      "value": "Sorry, we hit a snag. We're unable to retrieve your credit card information. Please try again later."
    },
    {
      "code": "biometrics.self.terms",
      "value": "I consent to the use of my biometric data for the purpose of:"
    },
    {
      "code": "biometrics.proxy.terms",
      "value": "I consent to the use of the biometric data of the guest I am checking in for the purpose of:"
    },
    {
      "code": "biometrics.checkbox.one",
      "value": "Boarding"
    },
    {
      "code": "biometrics.checkbox.two",
      "value": "Photography"
    },
    {
      "code": "arrival.time.unavailable",
      "value": "We are sorry but the selected arrival time is not longer available, please select a new one."
    },
    {
      "code": "ssp.ctc.gov.regulations.galapagos",
      "value": "Due to government regulations,  all guests are required to be at the Seymour Airport (Baltra Island) and checked in no later than 90 minutes prior to sail time."
    },
    {
      "code": "ssp.sailing.date",
      "value": "SAILING DATE"
    },
    {
      "code": "cuba.banner.message",
      "value": "<span>Guests traveling to Cuba must meet the requirements of one of the 12 categories of permitted travel authorized by the U.S. government.</span><a href='[url]' class='rcl-text-link' tabindex='0'  target='_blank'> Learn more</a><span> about travel requirements.</span>"
    },
    {
      "code": "photo.modal.error.resolution",
      "value": "Please use a high-resolution photo (minimum 960 x 960 pixels)."
    },
    {
      "code": "photo.modal.error.size",
      "value": "The image uploaded is too large. The image must be 10MB or less."
    },
    {
      "code": "photo.modal.error.format",
      "value": "The upload must be an image."
    },
    {
      "code": "photo.modal.error.webcam",
      "value": "The webcam is not available."
    },
    {
      "code": "photo.modal.error.resolution",
      "value": "The image resolution should be 960 x 960 pixels minimum."
    },
    {
      "code": "photo.modal.error.size",
      "value": "The image uploaded is too large. The image must be 10MB or less."
    },
    {
      "code": "photo.modal.error.format",
      "value": "The upload must be an image."
    },
    {
      "code": "photo.modal.error.webcam",
      "value": "The webcam is not available."
    },
    {
      "code": "ssp.key.pass",
      "value": "Key Pass"
    },
    {
      "code": "ssp.casino.pearl",
      "value": "PEARL"
    },
    {
      "code": "ssp.casino.onyx",
      "value": "ONYX"
    },
    {
      "code": "ssp.casino.amethyst",
      "value": "AMETHYST"
    },
    {
      "code": "ssp.casino.sapphire",
      "value": "SAPPHIRE"
    },
    {
      "code": "ssp.casino.ruby",
      "value": "RUBY"
    },
    {
      "code": "terms.of.service.modal.header",
      "value": "Terms of service"
    },
    {
      "code": "cc.tc.message1",
      "value": "The use of a credit card payment method is subject to the conditions found in our"
    },
    {
      "code": "cc.tc.message2",
      "value": "Terms of use."
    },
    {
      "code": "ssp.casino.title",
      "value": "CASINO"
    },
    {
      "code": "terms.of.service.paragraph1",
      "value": "<p align=\"center\">\n    <a name=\"0\">\n        <strong>Digital Terms of Use and End User License Agreement </strong>\n    </a>\n    <strong></strong>\n</p>\n<p align=\"center\">\n    <strong>(Last Updated: May 14, 2018)</strong>\n</p>\n<p align=\"center\">\n    <strong></strong>\n</p>\n<p>\n    <strong>\n        THIS IS AN IMPORTANT AND LEGALLY BINDING DOCUMENT. PLEASE READ THIS\n        DOCUMENT CAREFULLY AND IN ITS ENTIRETY.\n    </strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    The Terms of Use set forth herein (the “Terms”) govern your access to and\n    use of various websites, mobile application(s), kiosks, and other digital\n    platforms (together, the “Digital Platforms”) owned, operated, licensed or\n    controlled by Royal Caribbean Cruises Ltd., its subsidiaries, affiliates or\n    joint ventures (“we,” “us,” “our,” or the \"Company\").\n</p>\n<p>\n    Supplemental terms of sale and terms of use (the “Supplemental Terms”) may\n    apply to certain events, programs, activities or promotions, and such\n    Supplemental Terms may be disclosed to you separately. Any Supplemental\n    Terms and conditions are in addition to these Terms and, in the event of a\n    conflict, prevail over these terms.\n</p>\n<p>\n    <br/>\n    <strong>\n        BY CLICKING “I ACCEPT,” DOWNLOADING, INSTALLING, OR OTHERWISE ACCESSING\n        OR USING THE SERVICES, YOU AGREE THAT YOU HAVE READ AND UNDERSTOOD, AND\n        AGREE TO BE BOUND, BY THE FOLLOWING TERMS AND CONDITIONS, INCLUDING all\n        applicable laws and regulations (including export and re-export control\n        laws), and PRIVACY POLICY (TOGETHER, THE “TERMS”).\n    </strong>\n</p>\n<p>\n    <strong>\n        If you do not agree to the Terms, then you do not have our permission\n        to use the Digital Platforms.\n    </strong>\n</p>\n<p>\n    <a name=\"_Ref495088134\">\n        We reserve the right, at our discretion, to change these Terms on a\n        going-forward basis at any time. Please check these Terms periodically\n        for changes. If a change to these Terms materially modifies your rights\n        or obligations, you will be required to accept the modified Terms in\n        order to continue to use the\n    </a>\n    Digital Platforms. Material modifications are effective upon your\n    acceptance of the modified Terms. Immaterial modifications are effective\n    upon publication. Except as expressly permitted by this paragraph, these\n    Terms may be amended only by a written agreement signed by authorized\n    representatives of the parties to these Terms. Disputes arising under these\n    Terms will be resolved in accordance with the version of these Terms that\n    was in effect at the time the dispute arose.\n</p>\n<p>\n    <a name=\"1\"><strong>1. </strong><strong><u>General Terms</u></strong></a>\n</p>\n<p>\n    <strong><u></u></strong>\n</p>\n<p>\n    These Terms, together with the Privacy Policy and any other agreements\n    expressly incorporated by reference into these Terms, are the entire and\n    exclusive understanding and agreement between you and the Company regarding\n    your use of the Digital Platforms. You may not assign or transfer these\n    Terms or your rights under these Terms, in whole or in part, by operation\n    of law or otherwise, without our prior written consent. We may assign these\n    Terms at any time without notice or consent. The failure to require\n    performance of any provision will not affect our right to require\n    performance at any other time after that, nor will a waiver by us of any\n    breach or default of these Terms, or any provision of these Terms, be a\n    waiver of any subsequent breach or default or a waiver of the provision\n    itself. Use of section headers in these Terms is for convenience only and\n    will not have any impact on the interpretation of any provision. Throughout\n    these Terms the use of the word “including” means “including but not\n    limited to”. If any part of these Terms is held to be invalid or\n    unenforceable, the unenforceable part will be given effect to the greatest\n    extent possible, and the remaining parts will remain in full force and\n    effect.\n</p>\n<p>\n    <strong><u></u></strong>\n</p>\n<p>\n    <strong>2. </strong>\n    <strong><u>User Accounts and Registration</u></strong>\n</p>\n<p>\n    In order to use most aspects of the Digital Platforms, you must register\n    for and maintain an active personal user account (“<strong>Account</strong>\n    ”). You must be at least thirteen (13) years of age to obtain an Account.\n    If you are between the ages of 13 and 18, you represent and warrant that\n    you possess the legal consent of your parent or guardian to access and use\n    the Digital Platforms.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph2",
      "value": "<p>\n    Account registration requires you to submit to Company certain personal\n    information, such as your name, address, mobile phone number and date of\n    birth, among others. You agree to maintain accurate, complete, and\n    up-to-date information in your Account. Your failure to maintain accurate,\n    complete, and up-to-date Account information, may result in your inability\n    to access or use the Digital Platforms.\n</p>\n<p>\n    <strong>\n        It is a condition of your use of the Digital Platforms that you provide\n        user account registration details on behalf of yourself, and not\n        others. Although you may assist others in creating their own accounts,\n        you may not impersonate others on the Digital Platforms.\n    </strong>\n</p>\n<p>\n    You are responsible for all activity that occurs under your Account, and\n    you agree to maintain the security and secrecy of your Account username and\n    password at all times. Unless otherwise permitted by Company in writing,\n    you may only possess one Account. You may not assign or otherwise transfer\n    your Account to any other person or entity.\n</p>\n<p>\n    <strong>3. </strong>\n    <strong><u>Mobile Network </u></strong>\n    <u></u>\n</p>\n<p>\n    When you access the Digital Platforms through a mobile network, your\n    network or roaming provider’s messaging, data and other rates and fees will\n    apply. Downloading, installing or using certain Digital Platforms may be\n    prohibited or restricted by your network provider and not all Digital\n    Platforms may work with your network provider or device.\n</p>\n<p>\n    <strong>4. </strong>\n    <strong><u>Changes to the Digital Platforms </u></strong>\n</p>\n<p>\n    We reserve the right to withdraw or amend the Digital Platforms and any\n    material we provide on the Digital Platforms, in our sole discretion\n    without notice. We will not be liable if, for any reason, all or any part\n    of Digital Platforms is unavailable at any time or for any period. From\n    time to time, we may restrict access to some parts of the Digital\n    Platforms, or all Digital Platforms, to users, including registered users.\n</p>\n<p>\n    You are responsible for making all arrangements necessary for you to have\n    access to the Digital Platforms (including but not limited to obtaining any\n    necessary hardware and operating system software, or any internet\n    connectivity that may be required to access the Digital Platforms).\n</p>\n<p>\n    <strong>5. </strong>\n    <strong><u>Location Based Services </u></strong>\n</p>\n<p>\n    Some of the features of the Digital Platforms may enable the Company to\n    access your location in order to tailor your experience with the Digital\n    Platform(s) based on your location (\"Location-based Services\"). In order to\n    use certain Location-based Services, you must enable certain features of\n    your hardware (e.g., your mobile phone), which enable the Company to\n    identify your location through a variety of means, which may include IP\n    address, cell tower location, geo-fencing technology, or detection by\n    physical on-location Wi-Fi or Bluetooth sensors, as available. If you\n    choose to disable any Location-based Services on your device, you may not\n    be able to utilize certain features of the Digital Platforms. By enabling\n    Location-based Services, you agree and acknowledge that: (i) device data we\n    collect from you is directly relevant to your use of the Digital Platforms;\n    (ii) we may provide Location-based Services related to and based on your\n    then-current location; and (iii) we may use any such information collected\n    in connection with provision of the Digital Platforms.\n</p>\n<p>\n    <strong>6. </strong>\n    <strong><u>Guest to Guest Chat </u></strong>\n</p>\n<p>\n    <strong><u></u></strong>\n</p>\n<p>\n    Our Digital Platforms may make available to you, at no charge, a\n    guest-to-guest chat functionality that will enable you to stay connected\n    with friends and family while sailing (the “Chat”). Please note G2G Chat\n    functionality is available only while you are onboard one of our vessels,\n    and only when you are connected to our Royal WiFi.\n</p>\n<p>\n    Importantly, you will only be able to use G2G Chat to stay connected with\n    others in your reservation and/or stateroom. We may, in later releases,\n    provide you the ability to stay connected with other guests onboard that\n    are not in your traveling party.\n</p>\n<p>\n    We will retain G2G Chat history only for the duration of your voyage and we\n    will purge all chat history once your voyage ends. Our Privacy Policy, and\n    other applicable laws (including but not limited to the United States’\n    Stored Communications Act and the CLOUD Act) may apply with regard to the\n    privacy of the content included in your G2G Chat communications.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph3",
      "value": "<p>\n    You agree that you will not use G2G Chat to submit any material that you\n    know to be false, defamatory, inaccurate, abusive, vulgar, hateful,\n    harassing, obscene, profane, threatening, or invasive of another guest’s\n    privacy. You agree not to use G2G Chat to transmit any content intended to\n    incite or provoke violence.\n</p>\n<p>\n    To the extent you use G2G Chat to upload, submit, store, send or receive\n    content, you retain ownership of any intellectual property rights that you\n    hold in that content.\n</p>\n<p>\n    When you upload, submit, store, send or receive content to or through our\n    G2G Chat, you give us a worldwide license to use, host, store, reproduce,\n    modify, create derivative works (i.e., adaptations or other changes we make\n    so that your content works within our service), communicate, publish,\n    publicly perform, publicly display and distribute such content. You\n    represent and warrant that you have the necessary rights to grant us a\n    license for any content that you submit to G2G Chat.\n</p>\n<p>\n    The rights you grant in this license are for the limited purpose of\n    operating, promoting, and improving our Digital Platforms.\n</p>\n<p>\n    <strong>7. </strong>\n    <strong><u>Grant to You of a Limited License</u></strong>\n    <strong><u></u></strong>\n</p>\n<p>\n    The Digital Platforms and their entire contents, features and functionality\n    (including but not limited to all information, software, text, displays,\n    images, video and audio, and the design, selection and arrangement\n    thereof), are owned by the Company, its licensors or other providers of\n    such material and are protected by United States and international\n    copyright, trademark, patent, trade secret and other intellectual property\n    or proprietary rights laws.\n</p>\n<p>\n    Unless otherwise expressly noted, nothing that you read or see on any\n    Company Digital Platforms may be copied or used except as provided in these\n    Terms and Conditions of Use or with the prior written approval of Royal\n    Caribbean Cruises Ltd.\n</p>\n<p>\n    You must not reproduce, distribute, modify, create derivative works of,\n    publicly display, publicly perform, republish, download, store or transmit\n    any of the material on our Digital Platforms, except as follows:\n</p>\n<p>\n    · Your computer hardware or mobile device may temporarily store copies of\n    such materials in RAM incidental to your accessing and viewing those\n    materials;\n</p>\n<p>\n    · You may store files that are automatically cached by your web browser for\n    display enhancement purposes;\n</p>\n<p>\n    · You may print or download one copy of a reasonable number of pages of the\n    Digital Platforms for your own personal, non-commercial use and not for\n    further reproduction, publication or distribution; and\n</p>\n<p>\n    · You may download a single copy of any mobile application provided by the\n    Company to your mobile device solely for your own personal, non-commercial\n    use, provided you agree to be bound by our end user license agreement for\n    any such application(s).\n</p>\n<p>\n    This grant of permission is not a transfer of title, and under this\n    permission you may not:\n    <br/>\n    <br/>\n</p>\n<ul>\n    <li>\n        Modify copies of any materials from the Digital Platforms;\n    </li>\n</ul>\n<p>\n    · Use any illustrations, photographs, video or audio sequences or any\n    graphics separately from the accompanying text;\n</p>\n<p>\n    · Use the materials for any commercial purpose, or for any public display\n    (commercial or noncommercial);\n</p>\n<p>\n    · Remove any copyright or other proprietary notations from the materials;\n    or\n</p>\n<p>\n    · Transfer the materials to another person or \"mirror\" the materials on any\n    other server.\n</p>\n<p>\n    If you print, copy, modify, download or otherwise use or provide any other\n    person with access to any part of the Digital Platforms in breach of the\n    Terms of Use, your right to use the Digital Platforms will cease\n    immediately and you must, at our option, return or destroy any copies of\n    the materials you have made. No right, title or interest in or to the\n    Digital Platforms or any content on the Digital Platforms is transferred to\n    you, and all rights not expressly granted are reserved by the Company. Any\n    use of the Digital Platforms not expressly permitted by these Terms of Use\n    is a breach of these Terms of Use and may violate copyright, trademark and\n    other laws.\n</p>\n<p>\n    We make no warranties or representations to you that your use of any\n    materials displayed on a Company Digital Platforms will not infringe the\n    rights of third parties.\n</p>\n<p>\n    <a name=\"6\"><strong>8. </strong><strong><u>Digital Key</u></strong></a>\n</p>\n<p>\n    <strong><u></u></strong>\n</p>"
    },
    {
      "code": "terms.of.service.paragraph4",
      "value": "<p>\n    On some of our vessels, you may be able to use our mobile application to\n    open doors that you would otherwise access with a regular key (the “Digital\n    Key”). For example, you may be able to use a Digital Key to open the door\n    to your stateroom, a lounge, the gym, or certain other parts of the\n    vessels. You will need to opt-in to use this Digital Key functionality on\n    our mobile applications. You may use a standard key with (or in place of)\n    your Digital Key.\n</p>\n<p>\n    So long as you comply with these Terms, we will provide you with a\n    personal, revocable, limited, non-exclusive, non-sublicensable, and\n    non-transferable license to use the Digital Key provided to you. You use of\n    Digital Key is limited to your guest account. You may use your digital key\n    on any mobile device, as long as you are logged in to our mobile\n    application using your guest account. You may use the Digital Key to unlock\n    only those doors we authorize you to access. Your access privileges are to\n    be determined by us, in our sole discretion and may be suspended, revoked,\n    or terminated at any time with or without notice to you.\n</p>\n<p>\n    Your use of the Digital Key is further conditioned on your agreement to\n    maintain your mobile phone or device (and the Digital Key thereon) secured\n    and its contents confidential. You further agree that you will not allow a\n    third party or another person to use your Digital Key.\n</p>\n<p>\n    <strong>9. </strong>\n    <strong><u>Open Source Software</u></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    The Digital Platforms may include or incorporate third-party software\n    components that are generally available free of charge under licenses\n    granting recipients broad rights to copy, modify, and distribute such\n    components (“Open Source Components”). Although the Digital Platforms are\n    provided to you subject to these Terms, nothing in these Terms prevents,\n    restricts, or is intended to prevent or restrict you from obtaining such\n    Open Source Components under the applicable third-party licenses or to\n    limit your use of such Open Source Components thereunder.\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong>10. </strong>\n    <strong><u>Term, Termination of this Agreement</u></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    a. Term: These Terms are effective beginning when you accept the Terms or\n    download, install, access or use the Digital Platforms, and ending when\n    terminated as set for in Section 11.b.\n</p>\n<p>\n    b. Termination: If you violate any provision of these Terms, your account\n    and these Terms automatically terminate. In addition, the Company may, at\n    its sole discretion, terminate these Terms or your account on the Digital\n    Platforms, or suspend or terminate your access to the Digital Platforms at\n    any time for any reason or no reason, with or without notice. You may\n    terminate these Terms at any time by contacting customer service call\n    center. If you terminate these Terms, the Company reserves the right to\n    terminate your account.\n</p>\n<p>\n    c. Effect of Termination: Upon termination of these Terms: (i) your license\n    rights will terminate and you must immediately cease all use of the Digital\n    Platforms; and (ii) you will no longer have access to your account.\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong>11. </strong>\n    <strong><u>Feedback</u></strong>\n</p>\n<p>\n    If you choose to provide input and suggestions regarding problems with or\n    proposed modifications or improvements to the Digital Platforms\n    (“Feedback”), then you hereby grant the Company an unrestricted, perpetual,\n    irrevocable, non-exclusive, fully-paid, royalty-free right to exploit the\n    Feedback in any manner and for any purpose, including to improve the\n    Digital Platforms and create other products and services.\n</p>\n<p>\n    <strong>12. </strong>\n    <strong><u>Copyrights</u></strong>\n    <u>\n        <br/>\n        <br/>\n    </u>\n</p>\n<p>\n    Unless otherwise expressly noted, all materials, including images,\n    illustrations, designs, icons, and photographs appearing anywhere on the\n    Digital Platforms are protected by worldwide copyright laws and treaty\n    provisions.\n</p>\n<p>\n    None of the materials may be copied, reproduced, displayed, modified,\n    published, uploaded, posted, transmitted or distributed in any form or by\n    any means other than as described in the Linking Policy section or with the\n    Company’s prior written permission. All rights not expressly granted herein\n    are reserved. Any unauthorized use of the materials appearing on the\n    Digital Platforms may violate copyright, trademark and other applicable\n    laws and could result in criminal or civil penalties.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph5",
      "value": "<p>\n    <br/>\n    United States Government license rights, if any, in the materials appearing\n    on the Digital Platforms are limited to those mandatory rights identified\n    in ARS 252.227-7015(b) and all other applicable laws and regulations. All\n    other use is prohibited without the prior written approval of the Company.\n    Use of any of the materials appearing on the Digital Platforms by the\n    Government constitutes acknowledgment and acceptance of the Company's\n    proprietary rights in the materials.\n</p>\n<p>\n    <a name=\"7\"><strong>13. </strong><strong><u>Trademarks</u></strong></a>\n    <strong><u></u></strong>\n</p>\n<p>\n    <br/>\n    The Company’s name(s), the Company’s logo(s) and all related names, logos,\n    product and service names, designs and slogans are trademarks of the\n    Company or its affiliates or licensors. You must not use such marks without\n    the prior written permission of the Company. All other names, logos,\n    product and service names, designs and slogans on this Digital Platforms\n    are the trademarks of their respective owners.\n</p>\n<p>\n    No license or right is granted by implication, estoppel or any other means\n    to use any Trademark appearing on the Digital Platforms.\n</p>\n<p>\n    <br/>\n    Any use of the Company’s Trademark or linking the Digital Platforms must\n    follow the terms set out in the Linking Policy section. If you are unsure\n    whether a trademark, service mark, logo or graphic is the property of the\n    Company, or if you have any questions about the use of the Company’s\n    Trademarks, please contact us. The Company aggressively enforces its\n    intellectual property rights and will actively seek the recovery of any\n    fees, costs and damages it may incur preventing the misuse or\n    misappropriation of its intellectual property.\n</p>\n<p>\n    <strong>14. </strong>\n    <strong><u>Linking Policy Generally</u></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    You may link to any part of the Digital Platforms, provided you do so in a\n    way that is fair and legal and does not damage our reputation or take\n    advantage of it, but you must not establish a link in such a way as to\n    suggest any form of association, approval or endorsement on our part\n    without our express written consent.\n</p>\n<p>\n    <a name=\"co_anchor_a457429_1\"></a>\n    If the Digital Platforms contains links to other sites and resources\n    provided by third parties, these links are provided for your convenience\n    only. This includes links contained in advertisements, including banner\n    advertisements and sponsored links. We have no control over the contents of\n    those sites or resources and accept no responsibility for them or for any\n    loss or damage that may arise from your use of them. If you decide to\n    access any of the third party Digital Platforms linked to this Digital\n    Platforms, you do so entirely at your own risk and subject to the terms and\n    conditions of use for such Digital Platforms.\n</p>\n<p>\n    <strong>15. </strong>\n    <strong><u>Linking Policy for Travel Agents</u></strong>\n</p>\n<p>\n    <br/>\n    The Company encourages links to its Digital Platforms by bona fide travel\n    agents. Any such links to Digital Platforms must comply this Linking\n    Policy.\n</p>\n<p>\n    <br/>\n    Unless the Company provides the travel agent with prior authorization, in\n    writing, any link to Digital Platforms must use or include a Company\n    trademark. The Company grants travel agents a limited license to use these\n    logos for the specific purpose of creating and use such a link, but this\n    limited license does not transfer title in any trademark(s). The Company\n    trademark(s) may only be used as an active link to the appropriate Digital\n    Platforms.\n</p>\n<p>\n    Travel agents may not use the Company trademark(s) to imply that any\n    portion of the Company has sponsored or endorsed a travel agent Digital\n    Platforms without receiving the prior written permission of the Company.\n</p>\n<p>\n    Further, travel agents may not alter Company trademark(s) in any way,\n    including proportions or colors, and may not animate or morph the Company\n    trademark(s) to change their appearance.\n</p>\n<p>\n    Travel agents may also not use the Company trademark(s) on any Digital\n    Platforms which, in the Company's sole discretion, disparages the Company\n    or its affiliates, or their respective products or services.\n</p>\n<p>\n    Company trademark(s) may only be used on Digital Platforms which, in the\n    Company's sole discretion, make accurate references to the Company and its\n    products and/or services. The Company trademark(s) must be placed on the\n    same page as the reference to the Company and as close to any such\n    reference as feasible.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph6",
      "value": "<p>\n    Any link to a Company Digital Platforms must only be to that site's home\n    page. No \"deep linking\" to other pages on a Company Digital Platforms is\n    permitted without the Company's prior written consent.\n</p>\n<p>\n    The Company may, in its sole discretion, terminate a travel agent’s right\n    to use Company trademark(s) at any time. The Company may take action\n    against any use of the Company trademark(s) that does not conform to these\n    policies or that infringes any right held by the Company and will actively\n    seek the recovery of any costs it may incur preventing any such misuse or\n    damages that may result from such misuse.\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong>16. </strong>\n    <strong><u>Other Prohibited Uses</u></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    You may use the Digital Platforms only for lawful purposes and in\n    accordance with these Terms of Use. You agree not to use the Digital\n    Platforms:\n</p>\n<p>\n    • In any way that violates any applicable federal, state, local or\n    international law or regulation (including, without limitation, any laws\n    regarding the export of data or software to and from the US or other\n    countries).\n</p>\n<p>\n    • For the purpose of exploiting, harming or attempting to exploit or harm\n    minors in any way by exposing them to inappropriate content, asking for\n    personally identifiable information or otherwise.\n</p>\n<p>\n    • To transmit, or procure the sending of, any advertising or promotional\n    material without our prior written consent, including any “junk mail”,\n    “chain letter” or “spam” or any other similar solicitation.\n</p>\n<p>\n    • To impersonate or attempt to impersonate the Company, a Company employee,\n    another user or any other person or entity (including, without limitation,\n    by using e-mail addresses or screen names associated with any of the\n    foregoing).\n</p>\n<p>\n    • To engage in any other conduct that restricts or inhibits anyone’s use or\n    enjoyment of the Digital Platforms, or which, as determined by us, may harm\n    the Company or users of the Digital Platforms or expose them to liability.\n</p>\n<p>\n    Additionally, you agree not to:\n</p>\n<p>\n    • Use the Digital Platforms in any manner that could disable, overburden,\n    damage, or impair the site or interfere with any other party’s use of the\n    Digital Platforms, including their ability to engage in real time\n    activities through the Digital Platforms.\n</p>\n<p>\n    • Use any robot, spider or other automatic device, process or means to\n    access the Digital Platforms for any purpose, including monitoring or\n    copying any of the material on the Digital Platforms.\n</p>\n<p>\n    • Use any manual process to monitor or copy any of the material on the\n    Digital Platforms or for any other unauthorized purpose without our prior\n    written consent.\n</p>\n<p>\n    • Use any device, software or routine that interferes with the proper\n    working of the Digital Platforms.\n</p>\n<p>\n    • Introduce any viruses, trojan horses, worms, logic bombs or other\n    material which is malicious or technologically harmful.\n</p>\n<p>\n    • Attempt to gain unauthorized access to, interfere with, damage or disrupt\n    any parts of the Digital Platforms, the server on which the Digital\n    Platforms are stored, or any server, computer or database connected to the\n    Digital Platforms.\n</p>\n<p>\n    • Attack the Digital Platforms via a denial-of-service attack or a\n    distributed denial-of-service attack.\n</p>\n<p>\n    <strong>• </strong>\n    Otherwise attempt to interfere with the proper working of the Digital\n    Platforms.<strong></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong>17. </strong>\n    <strong><u>Reliance on Information Posted </u></strong>\n    <strong></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    The information presented on or through the Digital Platforms is made\n    available solely for general information purposes. We do not warrant the\n    accuracy, completeness or usefulness of this information. Any reliance you\n    place on such information is strictly at your own risk. We disclaim all\n    liability and responsibility arising from any reliance placed on such\n    materials by you or any other visitor to the Digital Platforms, or by\n    anyone who may be informed of any of its contents.\n</p>\n<p>\n    We may update the content on this Digital Platforms from time to time, but\n    its content is not necessarily complete or up-to-date. Any of the material\n    on the Digital Platforms may be out of date at any given time, and we are\n    under no obligation to update such material.\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong>18. </strong>\n    <strong><u>Purchases </u></strong>\n</p>"
    },
    {
      "code": "terms.of.service.paragraph7",
      "value": "<p>\n    <strong></strong>\n</p>\n<p>\n    All purchases through the Digital Platforms or other transactions for the\n    sale of goods, or services or information formed through the Digital\n    Platforms or as a result of visits made by you may be governed by separate\n    terms of sale and terms of use. Separate terms may be provided through the\n    Digital Platforms, onboard our vessels, or via a separate channel (i.e., a\n    port agent, prior to boarding).\n</p>\n<p>\n    We reserve the right to refuse or cancel any order prior to delivery. Some\n    situations that may result in your order being cancelled include system or\n    typographical errors, inaccuracies in product or pricing information or\n    product availability, fairness among customers where supplies are limited,\n    or problems identified by our credit or fraud departments. We also may\n    require additional verification or information before accepting an order.\n    We will contact you if any portion of your order is cancelled or if\n    additional information is required to accept your order.\n</p>\n<p>\n    When you provide payment information in connection with a purchase on the\n    Digital Platforms, you represent and warrant that the information is\n    accurate, that you are authorized to use the payment method provided, and\n    that you will notify us of changes to the payment information.\n</p>\n<p>\n    We may revise the pricing for products and services we offer. When you\n    place your order, we may estimate the tax and include that estimate in the\n    total for your convenience. The actual tax amount that will be applied to\n    your order and charged to your payment method may differ from the estimate\n    provided.\n</p>\n<p>\n    <a name=\"11\">\n        <strong>19. </strong>\n        <strong><u>Onboard Expense Account and Credit Card Charges</u></strong>\n    </a>\n</p>\n<p>\n    <u></u>\n</p>\n<p>\n    We require credit card information in order to set up an onboard expense\n    account for sailing guests (the “Onboard Expense Account”). You may set up\n    an Onboard Expense Account for you, your traveling party; or you may set up\n    an Onboard Expense Account for sailing guest(s) even though you may not be\n    part of a voyage.\n</p>\n<p>\n    More than one guest may use the same Onboard Expense Account. For example,\n    you and all others in your stateroom may charge onboard purchases to the\n    same Onboard Expense Account. By including other guests in your Onboard\n    Expense Account, you (a) authorize them to sign on behalf of the Onboard\n    Expense Account and (b) authorize their purchases to be charged to your\n    Onboard Expense Account and the credit card associated with it.\n</p>\n<p>\n    Prior to sailing, your Onboard Expense Account and the credit card\n    associated with your Onboard Expense Account will not reflect any charges\n    or authorizations.\n</p>\n<p>\n    By providing us credit card account information you certify you are the\n    named cardholder and you authorize us to charge the credit card account you\n    provide for any outstanding balance on the Onboard Expense Account prior to\n    the end of your voyage. You further agree to be personally liable for any\n    outstanding balance disputed by the credit card issuer.\n</p>\n<p>\n    Alternatively, in the event you are not the named cardholder, you certify\n    you (a) are an adult with full legal authority to enter into a contract on\n    behalf of the named cardholder, and (b) have received authorization from\n    the named cardholder for us to charge the credit card account you provide\n    for any outstanding balance on the Onboard Expense Account prior to the end\n    of your voyage. You further affirm that the named cardholder has had an\n    opportunity to read these Terms, and that they understand and accept all\n    these Terms. You further agree to be personally liable for any outstanding\n    balance disputed by the named cardholder.\n</p>\n<p>\n    <u></u>\n</p>\n<p>\n    <strong>20. </strong>\n    <strong><u>Vessel Operator</u></strong>\n    <u></u>\n</p>\n<p>\n    <br/>\n    Sailings may be operated by the Company, or its affiliates.\n    <strong>\n        See your passenger ticket contract for the identity of the specific\n        operator/carrier for your sailing.\n    </strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <a name=\"12\">\n        <strong>21. </strong>\n        <strong><u>Nonrefundable Deposit Program</u></strong>\n    </a>\n    <u></u>\n</p>\n<p>\n    A booking made under the non-refundable deposit cruise fare rate (an \"NRD\n    Booking\") requires the payment of a non-refundable deposit at the time of\n    booking. The deposit is not refundable at any time after it has been paid.\n    Payment of the full non-refundable deposit and the full name for each guest\n    is required at the time of booking. Deposits made toward Guarantees and\n    Grand Suites and higher categories are non-refundable and subject to NRD\n    Booking terms.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph8",
      "value": "<p>\n    <br/>\n    If a guest cancels an NRD Booking prior to the final payment due date, the\n    cancellation terms of the cruise ticket contract apply, and Royal Caribbean\n    International will issue a future cruise credit in the amount of the\n    deposit paid minus a $100 USD per person service fee to the guest named on\n    the cancelled NRD Booking (the \"FCC\"). The FCC is applicable only towards\n    the purchase of a Royal Caribbean International cruise and expires\n    12-months after the issue date (the \"Expiration Date\"). Any amount\n    remaining after the Expiration Date will be void and forfeited. The FCC is\n    non-transferable, non-refundable, and not redeemable for any other form of\n    compensation, credit, or cash. For NRD Bookings that require a deposit of\n    $100 USD or less, no FCC or any other compensation or credit of any kind\n    will be issued.\n</p>\n<p>\n    Each time the guest changes the ship or sail date of an NRD Booking prior\n    to the final payment due date, payments made towards the NRD Booking will\n    be applied to the balance of the modified booking and a $100 USD per person\n    service fee will be charged to the modified booking.\n    <br/>\n    <br/>\n    This offer is available exclusively to residents of United States and\n    Canada. Prices are subject to availability, subject to change without\n    notice; capacity controlled, and may be withdrawn at any time. The Company\n    reserves the right to correct any errors, inaccuracies or omissions and to\n    change or update fares, fees and surcharges at any time without prior\n    notice.\n</p>\n<p>\n    <strong>22. </strong>\n    <strong><u>Disclaimers; No Warranties</u></strong>\n</p>\n<p>\n    The Company has used reasonable efforts in collecting, preparing and\n    providing quality information and material, but does not warrant or\n    guarantee the accuracy, completeness, adequacy or currency of the\n    information contained in or linked to the Digital Platforms. We assume no\n    liability or responsibility for any errors or omissions in the content of\n    any Company Digital Platforms.\n    <strong>\n        The Company is not responsible for pricing, typographical, or other\n        errors and reserves the right to cancel without liability any bookings\n        made at erroneous rates.\n    </strong>\n</p>\n<p>\n    While the Company may make changes to the information in Digital Platforms\n    or to any Company service or product at any time without notice, the\n    Company makes no commitment to update the information on the Digital\n    Platforms.\n</p>\n<p>\n    TO THE FULLEST EXTENT PERMITTED BY LAW, THE SERVICE AND ALL MATERIALS AND\n    CONTENT AVAILABLE THROUGH THE SERVICE ARE PROVIDED “AS IS” AND ON AN “AS\n    AVAILABLE” BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, COMPANY DISCLAIMS\n    ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, RELATING TO THE\n    SERVICE AND ALL MATERIALS AND CONTENT AVAILABLE THROUGH THE SERVICE,\n    INCLUDING: (I) ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A\n    PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, OR NON-INFRINGEMENT; AND (II)\n    ANY WARRANTY ARISING OUT OF COURSE OF DEALING, USAGE, OR TRADE. TO THE\n    FULLEST EXTENT PERMITTED BY LAW, COMPANY DOES NOT WARRANT THAT THE SERVICE\n    OR ANY PORTION OF OR THE SERVICE, OR ANY MATERIALS OR CONTENT OFFERED\n    THROUGH THE SERVICE, WILL BE UNINTERRUPTED, SECURE, OR FREE OF ERRORS,\n    VIRUSES, OR OTHER HARMFUL COMPONENTS, AND DO NOT WARRANT THAT ANY OF THOSE\n    ISSUES WILL BE CORRECTED.\n</p>\n<p>\n    <br/>\n    THE COMPANY DOES NOT WARRANT THAT THE FUNCTIONS CONTAINED IN THE DIGITAL\n    PLATFORMS WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE\n    CORRECTED, OR THAT ANY COMPANY DIGITAL PLATFORMS OR THE SERVER(S) THAT\n    MAKES THE DIGITAL PLATFORMS AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL\n    COMPONENTS.\n</p>\n<p>\n    <br/>\n    NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM THE\n    SERVICE OR COMPANY ENTITIES OR ANY MATERIALS OR CONTENT AVAILABLE THROUGH\n    THE SERVICE WILL CREATE ANY WARRANTY REGARDING ANY OF THE COMPANY ENTITIES\n    OR THE SERVICE THAT IS NOT EXPRESSLY STATED IN THESE TERMS. TO THE FULLEST\n    EXTENT PERMITTED BY LAW, WE ARE NOT RESPONSIBLE FOR ANY DAMAGE THAT MAY\n    RESULT FROM YOUR USE OF OR ACCESS TO THE SERVICE AND YOUR DEALING WITH ANY\n    OTHER SERVICE USER. YOU UNDERSTAND AND AGREE THAT YOU USE THE SERVICE, AND\n    ACCESS, DOWNLOAD, OR OTHERWISE OBTAIN MATERIALS OR CONTENT THROUGH THE\n    SERVICE AND ANY ASSOCIATED SITES OR SERVICES, AT YOUR OWN DISCRETION AND\n    RISK, AND THAT, TO THE FULLEST EXTENT PERMITTED BY LAW, WE ARE NOT\n    RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER SYSTEM\n    OR MOBILE DEVICE(S) USED IN CONNECTION WITH THE SERVICE), OR THE LOSS OF\n    DATA THAT RESULTS FROM THE USE OF THE SERVICE OR THE DOWNLOAD OR USE OF THE\n    MATERIALS OR CONTENT.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph9",
      "value": "<p>\n    <br/>\n    APPLICABLE LAW MAY NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE\n    ABOVE EXCLUSION MAY NOT APPLY TO YOU.\n</p>\n<p>\n    <br/>\n    THIS DISCLAIMER OF LIABILITY APPLIES TO ANY DAMAGES OR INJURY CAUSED BY ANY\n    FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DELETION, DEFECT,\n    DELAY IN OPERATION OR TRANSMISSION, COMPUTER VIRUS, COMMUNICATION LINE\n    FAILURE, THEFT OR DESTRUCTION OR UNAUTHORIZED ACCESS TO, ALTERATION OF, OR\n    USE OF RECORD, WHETHER FOR BREACH OF CONTRACT, TORTIOUS BEHAVIOR,\n    NEGLIGENCE OR UNDER ANY OTHER CAUSE OF ACTION.\n</p>\n<p>\n    <strong>23. </strong>\n    <strong><u>Limitation on Liability </u></strong>\n    <strong><u></u></strong>\n</p>\n<p>\n    TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE COMPANY\n    ENTITIES BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL,\n    CONSEQUENTIAL OR PUNITIVE DAMAGES (INCLUDING DAMAGES FOR LOSS OF PROFITS,\n    GOODWILL, OR ANY OTHER INTANGIBLE LOSS) ARISING OUT OF OR RELATING TO YOUR\n    ACCESS TO OR USE OF, OR YOUR INABILITY TO ACCESS OR USE, THE SERVICE OR ANY\n    MATERIALS OR CONTENT ON THE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT,\n    TORT (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, AND\n    WHETHER OR NOT ANY COMPANY ENTITY HAS BEEN INFORMED OF THE POSSIBILITY OF\n    DAMAGE.\n</p>\n<p>\n    TO THE FULLEST EXTENT PERMITTED BY LAW, THE AGGREGATE LIABILITY OF THE\n    COMPANY ENTITIES TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE\n    USE OF OR ANY INABILITY TO USE ANY PORTION OF THE SERVICE OR OTHERWISE\n    UNDER THESE TERMS, WHETHER IN CONTRACT, TORT, OR OTHERWISE, IS LIMITED TO\n    $100.\n</p>\n<p>\n    EACH PROVISION OF THESE TERMS THAT PROVIDES FOR A LIMITATION OF LIABILITY,\n    DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS INTENDED TO AND DOES\n    ALLOCATE THE RISKS BETWEEN THE PARTIES UNDER THESE TERMS. THIS ALLOCATION\n    IS AN ESSENTIAL ELEMENT OF THE BASIS OF THE BARGAIN BETWEEN THE PARTIES.\n    EACH OF THESE PROVISIONS IS SEVERABLE AND INDEPENDENT OF ALL OTHER\n    PROVISIONS OF THESE TERMS. THE LIMITATIONS IN THIS SECTION WILL APPLY EVEN\n    IF ANY LIMITED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.\n</p>\n<p>\n    <strong>24. </strong>\n    <strong><u>Indemnification</u></strong>\n</p>\n<p>\n    You are responsible for your use of the Digital Platforms, and, to the\n    fullest extent permitted by law, you will defend and indemnify the Company\n    and its officers, directors, employees, consultants, affiliates,\n    subsidiaries and agents (together, the “Company Entities”) from and against\n    every claim, liability, damage, loss, and expense, including reasonable\n    attorneys’ fees and costs (“Claims”) brought by a third party arising out\n    of or connected with: (a) your use of, or misuse of, the Digital Platforms\n    not in compliance with these Terms; (b) your violation of any portion of\n    these Terms, any representation, warranty, or agreement referenced in these\n    Terms, or any applicable law or regulation; (c) your violation of any\n    third-party right, including any intellectual property right or publicity,\n    confidentiality, other property, or privacy right; or (d) any dispute or\n    issue between you and any third party. We reserve the right, at our own\n    expense, to assume the exclusive defense and control of any matter\n    otherwise subject to indemnification by you (without limiting your\n    indemnification obligations with respect to that matter), and in that case,\n    you agree to cooperate with our defense of those Claims.\n</p>\n<p>\n    <strong>25. </strong>\n    <strong><u>Governing Law</u></strong>\n    <strong>\n        <u>\n            <br/>\n            <br/>\n        </u>\n    </strong>\n</p>\n<p>\n    All matters relating to the Digital Platforms and these Terms of Use and\n    any dispute or claim arising therefrom or related thereto (in each case,\n    including non-contractual disputes or claims), shall be governed by and\n    construed in accordance with the laws of the State of Florida without\n    giving effect to any choice or conflict of law provision or rule (whether\n    of the State of Florida or any other jurisdiction).\n</p>\n<p>\n    <strong>26. </strong>\n    <strong><u>Dispute Resolution and Arbitration</u></strong>\n</p>"
    },
    {
      "code": "terms.of.service.paragraph10",
      "value": "<p>\n    <a name=\"_Ref495088297\">\n        In the interest of resolving disputes between you and Company in the\n        most expedient and cost-effective manner, you and Company agree that\n        every dispute arising in connection with these Terms will be resolved\n        by binding arbitration. Arbitration is less formal than a lawsuit in\n        court. Arbitration uses a neutral arbitrator instead of a judge or\n        jury, may allow for more limited discovery than in court, and can be\n        subject to very limited review by courts. Arbitrators can award the\n        same damages and relief that a court can award. This agreement to\n        arbitrate disputes includes all claims arising out of or relating to\n        any aspect of these Terms, whether based in contract, tort, statute,\n        fraud, misrepresentation, or any other legal theory, and regardless of\n        whether a claim arises during or after the termination of these Terms.\n        <strong>\n            YOU UNDERSTAND AND AGREE THAT, BY ENTERING INTO THESE TERMS, YOU\n            AND THE COMPANY ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO\n            PARTICIPATE IN A CLASS ACTION, AND THAT THIS AGREEMENT WILL BE\n            SUBJECT TO AND GOVERNED BY THE FEDERAL ARBITRATION ACT.\n        </strong>\n    </a>\n    <a name=\"_Ref495088285\"></a>\n</p>\n<p>\n    Nothing in these Terms will be deemed to waive, preclude, or otherwise\n    limit the right of either party to: (i) bring an individual action in small\n    claims court; (ii) pursue an enforcement action through the applicable\n    federal, state, or local agency if that action is available; (iii) seek\n    injunctive relief in aid of arbitration from a court of competent\n    jurisdiction; or (iv) to file suit in a court of law to address an\n    intellectual property infringement claim.\n</p>\n<p>\n    Any arbitration between you and Company will be settled under the Federal\n    Arbitration Act, and governed by the Commercial Dispute Resolution\n    Procedures and the Supplementary Procedures for Consumer Related Disputes\n    (collectively, “AAA Rules”) of the American Arbitration Association\n    (“AAA”), as modified by these Terms, and will be administered by the AAA.\nThe AAA Rules and filing forms are available online at www.adr.org, by calling the AAA at\n    1-800-778-7879, or by contacting Company. The arbitrator has exclusive\n    authority to resolve any dispute relating to the interpretation,\napplicability, or enforceability of this binding arbitration agreement.    <a name=\"_Ref495088266\"></a>\n</p>\n<p>\n    A party who intends to seek arbitration must first send a written notice of\n    the dispute to the other party by certified U.S. Mail or electronic mail\n    (“Notice”). Company’s address for Notice is: Royal Caribbean Cruises Ltd.,\n    1050 Caribbean Way, Miami, Florida 33132. The Notice must: (i) describe the\n    nature and basis of the claim or dispute; and (ii) set forth the specific\n    relief sought (“Demand”). The parties will make good faith efforts to\n    resolve the claim directly, but if the parties do not reach an agreement to\n    do so within 30 days after the Notice is received, you or Company may\n    commence an arbitration proceeding. During the arbitration, the amount of\n    any settlement offer made by you or Company must not be disclosed to the\n    arbitrator until after the arbitrator makes a final decision and award, if\n    any. If the dispute is finally resolved through arbitration in your favor,\n    Company will pay you the highest of the following: (A) the amount awarded\n    by the arbitrator, if any; (B) the last written settlement amount offered\n    by Company in settlement of the dispute prior to the arbitrator’s award; or\n    (C) $15,000.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph11",
      "value": "<p>\n    Any arbitration hearing will take place at a location to be agreed upon in\n    Miami-Dade County, Florida. If the arbitrator finds that either the\n    substance of your claim or the relief sought in the Demand is frivolous or\n    brought for an improper purpose (as measured by the standards set forth in\n    Federal Rule of Civil Procedure 11(b)), then the payment of all fees will\n    be governed by the AAA Rules. In that case, you agree to reimburse Company\n    for all monies previously disbursed by it that are otherwise your\n    obligation to pay under the AAA Rules. Regardless of the manner in which\n    the arbitration is conducted, the arbitrator must issue a reasoned written\n    decision sufficient to explain the essential findings and conclusions on\n    which the decision and award, if any, are based. Each party agrees that\n    such written decision, and information exchanged during arbitration, will\n    be kept confidential except to the extent necessary to enforce or permit\n    limited judicial review of the award. The arbitrator may make rulings and\n    resolve disputes as to the payment and reimbursement of fees or expenses at\n    any time during the proceeding and upon request from either party made\n    within 14 days of the arbitrator’s ruling on the merits.\n</p>\n<p>\n    <a name=\"_Ref495088309\">\n        YOU AND THE COMPANY AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER\n        ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS\n        MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Further,\n        unless both you and Company agree otherwise, the arbitrator may not\n        consolidate more than one person’s claims and may not otherwise preside\n        over any form of a representative or class proceeding.\n    </a>\n</p>\n<p>\n    If Company makes any future change to this arbitration provision, other\n    than a change to Company’s address for Notice, you may reject the change by\n    sending us written notice within 30 days of the change to Company’s address\n    for Notice, in which case your account with the Company and access to the\n    Digital Platforms will be immediately terminated and this arbitration\n    provision, as in effect immediately prior to the changes you rejected will\n    survive.\n</p>\n<p>\n    <strong>27. </strong>\n    <strong><u>Limitation on Time to File Claims</u></strong>\n</p>\n<p>\n    <strong>\n        ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO\n        THESE TERMS OF USE OR THE DIGITAL PLATFORMS MUST BE COMMENCED WITHIN\n        ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE, SUCH CAUSE\n        OF ACTION OR CLAIM IS PERMANENTLY BARRED.\n    </strong>\n</p>\n<p>\n    <strong>28. </strong>\n    <strong><u>Notice to California Residents </u></strong>\n</p>\n<p>\n    If you are a California resident, under California Civil Code Section\n    1789.3, you may contact the Complaint Assistance Unit of the Division of\n    Consumer Services of the California Department of Consumer Affairs in\n    writing at 1625 N. Market Blvd., Suite S-202, Sacramento, California 95834,\n    or by telephone at (800) 952-5210 in order to resolve a complaint regarding\n    the Digital Platforms or the Company or to receive further information\n    regarding use of the Digital Platforms.\n</p>\n<p>\n    <strong>29. </strong>\n    <strong><u>Consent to Electronic Communications</u></strong>\n    <u> </u>\n</p>\n<p>\n    By using the Digital Platforms, you consent to receiving certain electronic\n    communications from us as further described in our Privacy Policy. Please\n    read our Privacy Policy to learn more about our electronic communications\n    practices. You agree that any notices, agreements, disclosures, or other\n    communications that we send to you electronically will satisfy any legal\n    communication requirements, including that those communications be in\n    writing.\n</p>\n<p>\n    <strong>30. </strong>\n    <strong>\n        <u>Notice Regarding Google, Inc. or Microsoft Corporation</u>\n    </strong>\n</p>\n<p>\n    If you access the Digital Platforms using an Android or Microsoft\n    Windows-powered device, Google, Inc. or Microsoft Corporation,\n    respectively, shall be a third-party beneficiary to this contract. However,\n    these third-party beneficiaries are not a party to this contract and are\n    not responsible for the provision or support of the Digital Platforms. You\n    agree that your access to the Digital Platforms using these devices also\n    shall be subject to the usage terms set forth in the applicable third-party\n    beneficiary’s terms of service.\n</p>\n<p>\n    <strong>31. </strong>\n    <strong><u>Notice Regarding PTC, Inc.</u></strong>\n</p>\n<p>\n    Certain of our Digital Platforms may use software owned or developed by\n    PTC, Inc. (“PTC” and the “PTC Software”). By using our Digital Platforms\n    containing said software, you:\n</p>"
    },
    {
      "code": "terms.of.service.paragraph12",
      "value": "<p>\n    a. Consent to the collection, storage, and use by PTC and its affiliates\n    and service providers of Statistics and, if applicable, camera views from\n    the PTC Software and the of statistics (and camera views if applicable)\n    between PTC and its affiliates and service providers (which may be in the\n    United States or in other countries), in each case for the purposes of (a)\n    providing the software, (b) facilitating the provision of new products,\n    updates, enhancements and other services, (c) improving the PTC Software,\n    and other products, services and technologies, and (c) providing new\n    products, services or technologies to customers of PTC or its affiliates;\n</p>\n<p>\n    b. Are advised of the hazards of using a camera-based application while\n    walking, or otherwise by being distracted or disoriented from real-world\n    situations;\n</p>\n<p>\n    c. Except as expressly authorized by this Agreement, you may not directly\n    or through any third party or device: (a) use, display, reproduce, modify,\n    or create derivative works of the PTC Software; (b) distribute the PTC\n    Software to a third party, in whole or in part; (c) attempt to derive the\n    source code of the PTC Software; (d) use the PTC Software to develop or to\n    modify products that are intended for commercial distribution by third\n    parties; (e) register any trademark, service mark, trade name, copyright,\n    or company name which is identical or confusingly similar to PTC’s or is a\n    translation into other languages; (f) incorporate PTC’s logo or any other\n    PTC trademark into product names, service names, company names, domain\n    names, or any other similar designations; (g) alter, obscure or delete any\n    copyright notices and trademarks in the PTC Software; or (h) distribute,\n    market, sublicense or resell the PTC Software on a standalone basis for\n    standalone use.\n</p>"
    },
    {
      "code": "terms.of.service.paragraph13",
      "value": "<p>\n    <strong>32. </strong>\n    <strong><u>Notice Regarding Apple, Inc. </u></strong>\n</p>\n<p>\n    This Section only applies to the extent you are using our mobile\n    application(s) on an iOS device. You acknowledge that these Terms are\n    between you and Company only, not with Apple Inc. (\"Apple\"), and Apple is\n    not responsible for the Digital Platforms and the content thereof. Apple\n    has no obligation whatsoever to furnish any maintenance and support\n    services with respect to the Digital Platforms. In the event of any failure\n    of the Digital Platforms to conform to any applicable warranty, you may\n    notify Apple and Apple will refund any applicable purchase price for the\n    mobile application to you; and, to the maximum extent permitted by\n    applicable law, Apple has no other warranty obligation whatsoever with\n    respect to the Digital Platforms. Apple is not responsible for addressing\n    any claims by you or any third party relating to the Digital Platforms or\n    your possession and/or use of the Digital Platforms, including: (i) product\n    liability claims; (ii) any claim that the Digital Platforms fails to\n    conform to any applicable legal or regulatory requirement; and (iii) claims\n    arising under consumer protection or similar legislation. Apple is not\n    responsible for the investigation, defense, settlement and discharge of any\n    third-party claim that the Digital Platforms and/or your possession and use\n    of the Digital Platforms infringe third party's intellectual property\n    rights. You agree to comply with any applicable third-party terms when\n    using the Digital Platforms. Apple and Apple's subsidiaries are third party\n    beneficiaries of these Terms, and upon your acceptance of these Terms,\n    Apple will have the right (and will be deemed to have accepted the right)\n    to enforce these Terms against you as a third-party beneficiary of these\n    Terms. You hereby represent and warrant that (i) you are not located in a\n    country that is subject to a U.S. Government embargo, or that has been\n    designated by the U.S. Government as a \"terrorist supporting\" country; and\n    (ii) you are not listed on any U.S. Government list of prohibited or\n    restricted parties.\n</p>\n<p>\n    <strong>33. </strong>\n    <strong><u>Waiver and Severability</u></strong>\n</p>\n<p>\n    No waiver of by the Company of any term or condition set forth in these\n    Terms shall be deemed a further or continuing waiver of such term or\n    condition or a waiver of any other term or condition, and any failure of\n    the Company to assert a right or provision under these Terms shall not\n    constitute a waiver of such right or provision.\n</p>\n<p>\n    If any provision of these Terms is held to be invalid, illegal or\n    unenforceable for any reason, such provision shall be eliminated or limited\n    to the minimum extent such that the remaining provisions of the Terms will\n    continue in full force and effect.\n</p>\n<p>\n    <a name=\"co_anchor_a361445_1\"></a>\n    <strong>34. </strong>\n    <strong><u>Entire Agreement</u></strong>\n</p>\n<p>\n    The Terms of Use constitute the sole and entire agreement between you and\n    the Company with respect to the Digital Platforms and supersede all prior\n    and contemporaneous understandings, agreements, representations and\n    warranties, both written and oral, with respect to the Digital Platforms.\n</p>"
    },
    null,
    {
      "code": "mobile.app.ad.long.title",
      "value": "<strong>Check in</strong> on the Celebrity Cruises app"
    },
    {
      "code": "mobile.app.ad.short.title",
      "value": "<strong>Check in</strong> on the Celebrity app"
    },
    {
      "code": "mobile.app.ad.paragraph",
      "value": "The fastest way to board, plus bypass the counter with our <strong>Expedited Arrival</strong> boarding program.*"
    },
    null,
    null,
    null,
    null,
    null,
    {
      "code": "app.modal.header",
      "value": "Check in on the Celebrity Cruises app"
    },
    {
      "code": "app.modal.subheader",
      "value": "The fastest way to board, plus bypass the counter with our Expedited Arrival boarding program.*"
    },
    {
      "code": "app.modal.footnote",
      "value": "*Expedited Arrival is available to select guests using the Celebrity Cruises app."
    },
    {
      "code": "biometric.consent.paragraph",
      "value": "I consent to the use of my biometric data and the biometric data of each guest I am checking in, on whose behalf I am legally authorized to provide consent."
    },
    {
      "code": "biometric.consent.link",
      "value": "View biometric data policy"
    },
    {
      "code": "data.privacy.modal.header",
      "value": "Biometric Processing Privacy Policy"
    },
    null,
    {
      "code": "data.privacy.modal.content1",
      "value": "<p align=\"center\">\n    <strong>Royal Caribbean Biometric Processing Privacy Policy </strong>\n</p>\n<p>\n    1. Highlights\n</p>\n<p>\n    1.1 <strong>Your privacy matters.</strong> We want you to understand how We\n    use the personal data you provide to Us.\n</p>\n<p>\n    1.2 <strong>We collect and process data about you.</strong> We collect and\n    process your personal data, including certain sensitive personal data, to\n    provide you goods and/or services offered by Us or through Our third party\n    suppliers.\n</p>\n<p>\n    1.3 <strong>We need to use your data.</strong> We need to use your personal\n    data in furtherance of the provision of goods and/or services and the\n    operation of Our business.\n</p>\n<p>\n    1.4 <strong>We need to share your data.</strong> As a global business, We\n    share certain personal data with other companies within the Royal Caribbean\n    Group (Royal Caribbean and Celebrity Cruises), other\n    suppliers and business partners. We choose Our suppliers and business\n    partners carefully and put in place safeguards to ensure that they protect\n    your personal data.\n</p>\n<p>\n    2. Who\'s responsible for your personal data referenced in this Privacy\n    Notice?\n</p>\n<p>\n    References to \"We\", \"Us\" or \"Our\" in this privacy notice mean the data\n    controller who is responsible for the processing of personal data\n    referenced in this Privacy Notice. The data controller can be determined as\n    follows:\n</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">Royal Caribbean Cruises Ltd. of 1050 Caribbean Way, Miami, Florida 33132,</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">USA, (&ldquo;Royal&rdquo;) <span style=\"font-family: 'inherit',serif; color: #333333;\">if (i) you are sailing on Our Royal vessels, (ii) </span>if you<span style=\"font-family: 'inherit',serif; color: #333333;\"> use Our websites, mobile application(s), or shipboard kiosks outside of the European Economic Area (EEA), or (iii) if you booked your cruise through an entity based outside of the EEA</span>;</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">&nbsp;</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">Celebrity Cruises Inc. of 1050 Caribbean Way, Miami, FL 33132, USA,</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">(&ldquo;Celebrity&rdquo;) <span style=\"font-family: 'inherit',serif; color: #333333;\">if (i) you are sailing on Our Celebrity vessels, (ii) </span>if <span style=\"font-family: 'inherit',serif; color: #333333;\">you use Our Websites, mobile application(s), or shipboard kiosks outside of the EEA, or</span> (iii) if you booked your cruise through an entity based outside of the EEA; or</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">&nbsp;</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">RCL Cruises Ltd., Building 7, The Heights, Brooklands, Weybridge, Surrey</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">KT13 OXW, UK, (&ldquo;RCL&rdquo;) if (i) <span style=\"font-family: 'inherit',serif; color: #333333;\">you use Our websites inside the EEA, Australia, and New Zealand, (ii) if you use Our mobile application(s) or shipboard kiosks inside of the EEA, or (iii)</span> <span style=\"font-family: 'inherit',serif; color: #333333;\">you book a cruise through an entity based inside of the EEA</span>.</p>\n<p style=\"text-align: justify; text-indent: -.5in; line-height: 14.0pt; tab-stops: list 1.0in; margin: 0in 0in 9.0pt 1.0in;\">&nbsp;</p>\n<p>\n    3. What personal data we collect, how we use it, who we share it with, and\n    how long we keep it\n</p>\n<p>\n    3.1 Before your cruise, We collect certain identifying information (your\n    name, address, booking number, identification and travel documents\n    (passport, visa, etc.). In addition, We collect your photograph; you may\n    provide Us a photograph (e.g. through Our mobile app (and please note that\n    Royal Caribbean and Celebrity Cruises each have\n    their own mobile app) (<strong><em>App</em></strong>) or via your Check-in\non www.royalcaribbean.com) and/or We may take your photograph (    <strong><em>Photograph</em></strong>). The Photograph is used to further\n    identify you before and during your cruise.\n</p>"
    },
    {
      "code": "data.privacy.modal.content2",
      "value": "<p>\n    3.2 Royal, acting as a controller in its own name or acting as a processor\n    for Celebrity and RCL, and Our provider for onboard photography services,\n    Image, acting as Our data processor, may process this Photograph and\n    extract certain data from the Photograph (e.g. biometric data) so as to\n    better identify you. The manner in which Image will use this data is\n    described in more detail in Annex A below.\n</p>\n<p>\n    3.3 This processing is used to create efficiencies in Our offering of goods\n    and/or services with resultant convenience to you. We use your biometric\n    data (where you have consented for Us to do so) for Frictionless Arrival\n    and for use of the onboard photography service, as described in more detail\n    below.\n</p>\n<p>\n    <strong><u>Frictionless Arrival</u></strong>\n    <strong> </strong>\n</p>\n<p>\n    3.4 At most ports of entry (e.g. airports, seaports, etc.), check-in and\n    embarkation are time-consuming processes requiring manual review of\n    identifying information and documents (e.g. photo identification, etc.).\n</p>\n<p>\n    3.5 Frictionless Arrival reduces this time so Our customers can start\n    enjoying their cruise earlier. By processing biometric data from your\n    Photograph, cameras in Our Frictionless Arrival lane will be able to\n    identify you, using biometric data and facial recognition, without the need\n    for further identification.\n</p>\n<p>\n    <strong><u>Onboard Photography and Related Services</u></strong>\n</p>\n<p>\n    3.6 Purchasing onboard photography used to require the time-consuming\n    process of manually scouring the walls of photographs taken by onboard\n    photographer(s) to find your photograph(s).\n</p>\n<p>\n    3.7 To help to simplify this process, we will transfer your Photograph to\n    Our provider for onboard photography services, Image. Image’s use of your\n    personal data is described in more detail in Annex A below. Where you have\n    given your consent for the processing of your biometric data for these\n    purposes and as described in Annex A, Image will then use their own\n    software for facial recognition to identify your biometric data contained\n    in the Photograph. By using that biometric data, Image will be able to\n    identify you in photograph(s) taken by their onboard photographer(s) and\n    provide those photograph(s) to you without you having to search for them.\n</p>\n<p>\n    3.8 Photographs and related biometric data are maintained for the limited\n    purposes set forth in paragraphs 3.4 to 3.7 above. We will not use your\n    biometric data for any other purposes and will permanently destroy\n    biometric data within six weeks of the end of the applicable voyage, unless\n    the further retention of such data is permitted by applicable law.\n</p>\n<p>\n    4. Legal basis for the processing of your personal data\n</p>\n<p>\n    4.1 Notwithstanding any other legal basis for the collection and processing\n    of your identifying information, including your Photograph, the processing\n    of your biometric data as described in paragraph 3 is based on your\n    consent.\n</p>\n<p>\n    4.2 Your consent to one or more of the processing activities in paragraph 3\n    is voluntary and can be withdrawn at any time up until 3 (three) days prior\n    to your sail date through Check-in on Our website or App. Additionally,\n    withdrawal of consent for processing of your data for the purposes of\n    Frictionless Arrival can be managed at the port on the day of sailing,\n    where you will use the manual check-in process rather than Frictionless\n    Arrival. You may also withdraw consent for processing of your data for the\n    purposes of onboard photography services by opting out at the onboard\n    photography kiosk. For the avoidance of doubt, there will be no processing\n    of the biometric data obtained from your Photograph between the time of the\n    closure of Check-in through Our website or through Our App and the time of\n    your arrival at the port for the departure of your cruise.\n</p>\n<p>\n    Your choice not to give consent will not result in any significant negative\n    consequences; however, you will not be able to avail yourself of one or\n    more of the services described in paragraph 3.\n</p>\n<p>\n    4.3 Please note that the revocation of any previously given consent will\n    not affect the lawfulness of processing based on the consent before its\n    revocation and We explicitly reserve the right to process and/or continue\n    to process- notwithstanding consent or the lack thereof- insofar as there\n    is another legal basis for such processing.\n</p>\n<p>\n    5. International transfer of data\n</p>"
    },
    {
      "code": "data.privacy.modal.content3",
      "value": "<p>\n    In the event We transfer your data from inside the European Economic Area\n    (“EEA”) to countries outside the EEA (e.g. to Our supplier Image or to\n    Royal) We will use the European Commission’s Standard Contractual Clauses\n    (also known as Model Clauses) to provide safeguards for your personal data\n    that is transferred outside the EEA so you can rest assured that We seek to\n    adhere to the strict European standards of data security and usage.\n</p>\n<p>\n    6. Your rights\n</p>\n<p>\n    Certain additional rights apply to you if:\n</p>\n<p>\n    a. you use Our Digital Platforms while in the EEA to provide your\n    Photograph and to consent to one or more of the activities described in\n    paragraph 3 above; or\n</p>\n<p>\n    b. your data controller is RCL (to determine your data controller, see\n    paragraph 2 above).\n</p>\n<p>\n    If you meet either of the criteria listed above, you may have, subject to\n    the requirements set forth under applicable data protection law, the right\n    to ask Us to:\n</p>\n<p>\n    (i) provide you with access to the personal data that We hold about you;\n</p>\n<p>\n    (ii) correct your personal data;\n</p>\n<p>\n    (iii) erase your personal data;\n</p>\n<p>\n    (iv) restrict our processing of your personal data; or\n</p>\n<p>\n    (v) object to our processing of your personal data.\n</p>\n<p>\n    To exercise any of these options, please submit your request through the\n    Guest Data Subject Request Form.\n</p>\n<p>\n    You also have the right to request that We move your personal data to\n    another organisation or to object to Us using your personal data for\n    profiling or direct marketing purposes. You can exercise these rights by\n    using the Submit an Inquiry button in the Guest Data Subject Request Form.\n</p>\n<p>\n    You also have the right to make a complaint about how We process your\n    personal data to your data protection supervisory authority.\n</p>\n<p>\n    7. Further information\n</p>\n<p>\n    If you have questions regarding the use of personal data referenced in this\n    Privacy Notice, you may contact Our data protection officer at\n    privacy@rccl.com.\n</p>\n<p>\n    For further information regarding the use of personal data, please see Our\n    Privacy Policy available on our corporate website.\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<strong>\n    <br clear=\"all\"/>\n</strong>\n<p align=\"center\">\n    <strong>Annex A:</strong>\n    <strong></strong>\n</p>\n<p align=\"center\">\n    <strong>Image’s Privacy Notice</strong>\n</p>\n<p align=\"center\">\n    <strong>Onboard Photography Services</strong>\n</p>\n<p align=\"center\">\n    <strong>\n        <em>(Royal Caribbean International and Celebrity guests only)</em>\n    </strong>\n</p>\n<p align=\"center\">\n    <strong><em></em></strong>\n</p>\n<p>\n    <strong>1. </strong>\n    <strong>Introduction</strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    <strong>The Image Group</strong>\n, PO BOX 10310, Grand Cayman, Cayman Islands, KY1-1003 (“<strong>TIG</strong>”, “<strong>we</strong>”, “<strong>us</strong>\"; “<strong>our</strong>”) has been appointed by<strong>Royal Caribbean International</strong> and    <strong>Celebrity Cruises</strong> (each a “<strong>Cruise Line</strong>”)\nto provide and manage professional photography services (the “    <strong>Services</strong>”) onboard their cruise ships. This Privacy Notice\n    applies to you if you request, agree or acquiesce to a TIG photographer\n    taking a photograph of you alone or with one or more passengers onboard a\n    Cruise Line’s ship and/or if you use any of the Services.\n</p>\n<p>\n    You may sometimes provide us with personal data relating to third parties,\n    such as persons who will be partaking in a Photo Event (as defined below)\n    or other passengers who are travelling with you. Before giving us this\n    information please inform those third parties that you intend to disclose\n    their personal data to us, the purpose for this disclosure, and that their\n    personal data will be processed in accordance with this Privacy Notice.\n</p>\n<p>\n    Please note that we only collect and process your personal data for and on\n    behalf of the Cruise Line with whom you travel, whose identity should be\n    set out in your travel documents. TIG does not use your personal data for\n    any purpose other than those purposes which are set out in this Privacy\n    Notice, or as directed by your Cruise Line. For further information on the\n    manner in which your Cruise Line processes your personal data, please\n    contact your Cruise Line directly.\n</p>"
    },
    {
      "code": "data.privacy.modal.content4",
      "value": "<p>\n    If you are in the European Union you have data protection rights under the\nGeneral Data Protection Regulation (Regulation (EU) 2016/679) (“    <strong>GDPR</strong>”) as implemented into national law and as each may be\namended, extended or re-enacted from time to time (collectively “    <strong>Data Protection Legislation</strong>”). Where the GDPR applies to\n    the personal data we receive about you, you will enjoy full rights under\n    the GDPR as a “data subject”. Where the GDPR does not apply to your\n    personal data, you will not have data protection rights under the GDPR. In\nthis Privacy Notice, the terms “<strong>controlle</strong>r”; “<strong>data subject</strong>”; “<strong>personal data</strong>”; \"    <strong>processor</strong>\"; “<strong>processing</strong>” (and any\n    derivatives of this term) and “<strong>biometric data</strong>” each have\n    the meaning given under Data Protection Legislation. Please note that\n    “personal data” does not include data where the identity has been removed\n    (i.e. anonymous data).\n</p>\n<p>\n    <strong>2. </strong>\n    <strong>Types Of Personal Data We Process</strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    If you use any of the Services onboard or after your cruise, we may process\n    the following types of personal data on behalf of your Cruise Line:\n</p>\n<p>\n    <strong>a. </strong>\n    <strong>Your Photo Event Image</strong>\n</p>\n<p>\n    We provide the Cruises Line’s guests the opportunity to participate in\nindividual and group photography opportunities, which are called “    <strong>Photo Events</strong>” and are categorized as follows:\n</p>\n<ul>\n    <li>\n        <strong>Embarkation </strong>\n– at designated points when guests are boarding a ship.        <strong></strong>\n    </li>\n    <li>\n        <strong>Gangway </strong>\n        – when guests are using gangway platforms at ports of call to embark\n        and disembark a ship.\n    </li>\n    <li>\n        <strong>Restaurants </strong>\n        – when guests are present in dining rooms, bars, lounges and similar on\n        a ship.\n    </li>\n    <li>\n        <strong>Portraits </strong>\n        – at portrait sessions at various locations on a ship.\n    </li>\n    <li>\n        <strong>Private Portraiture </strong>\n        - exclusive private studio photo session at various locations on a\n        ship.\n    </li>\n    <li>\n        <strong>Rides </strong>\n        – the Cruise Line has installed automated cameras on certain amusement\n        rides on ships and TIG is provided with the photographs from these\n        rides by the Cruise Line.\n    </li>\n</ul>\n<p>\n    <strong></strong>\n</p>\n<p>\n    Having your photograph taken by one of TIG’s photographers is entirely your\n    choice. If you choose to have your photograph taken at Photo Events, alone\n    or as part of a group, TIG will receive your image as contained in the\n    photograph(s) (a “<strong>Photo Event Image</strong>”).\n</p>\n<p>\n    Photographs do not contain any personal information that will identify you\n    to us unless you provide your SeaPass card to the TIG photographer for\n    swiping at a Photo Event. If you provide your SeaPass card, your photograph\n    will automatically be allocated to your stateroom photo kiosk account. If\n    you do not provide your SeaPass card, you will be able to search for your\n    photograph using TIG’s “Digital PhotoFinder” which can be accessed at the\n    photo kiosks in the photo gallery onboard the ship. The photograph will\n    only be approved for allocation to your stateroom photo kiosk account once\n    it has been manually verified by us against your security photo which is\n    given to us by your Cruise Line. This security measure is intended to\n    protect the privacy of all guests onboard a ship.\n</p>\n<p>\n    <strong>Group photos</strong>\n    – if you choose to have your photograph taken by a TIG photographer with\n    one or more guests other than those in your stateroom, those guests will be\n    entitled to access and purchase the photograph even if you choose not to\n    purchase it. If you do not wish other guests to purchase photographs which\n    include you or others in your stateroom, we ask that you do not participate\n    in group photographs at Photo Events.\n</p>\n<p>\n    <strong>b. </strong>\n    <strong>Biometric Data</strong>\n    <strong></strong>\n</p>"
    },
    {
      "code": "data.privacy.modal.content5",
      "value": "<p>\n    <strong>\n        If you consent, and if each of the guests in your stateroom consent\n    </strong>\n    , TIG will use facial recognition services to identify you in the\n    photographs we take at Photo Events so that we can automatically allocate\n    your photographs to your stateroom photo kiosk account when your SeaPass\n    card has not been swiped at a Photo Event. In order to use this service, we\n    process your facial features, facial characteristics and facial geometry as\n    contained in your Cruise Line security photo (as provided by your Cruise\n    Line) and as contained in photographs taken by a TIG photographer at Photo\n    Events that were swiped using your SeaPass card. We process this personal\n    data together with Cruise Line Provided Data (defined below) in order to\n    automatically allocate photographs to your stateroom photo kiosk account.\n</p>\n<p>\nUse of this facial recognition service involves the processing of<strong>biometric data</strong> for the purpose of identifying you. Your    <strong>explicit consent</strong> is needed in order to avail of this\n    service. Your biometric data will only be processed by TIG if you have\n    provided your explicit consent, and if each of the guests in your stateroom\n    also provide their explicit consent. Your explicit consent may be (i) given\n    to your Cruise Line before you sail, during the Cruise Line's check-in\n    process; or (ii) obtained by TIG using the photo kiosks in the photo\n    gallery onboard the Cruise Line’s ship.\n</p>\n<p>\n    Your biometric data is: (i) kept in a dedicated and secure location onboard\n    the Cruise Line’s ship; (ii) held on a system that is not connected to the\n    Internet or any outside system; (iii) never shared with third parties,\n    including your Cruise Line; (iv) deleted within 6 weeks after your cruise\n    has ended.\n</p>\n<p>\n    Your consent may be withdrawn at any time by using the photo kiosks in the\n    photo gallery onboard the ship. If you withdraw your consent, we will stop\n    using facial recognition services to allocate your photographs to your\n    stateroom photo kiosk account. However, this will not affect the lawfulness\n    of any processing of personal data carried out before consent is withdrawn.\n    If consent is withdrawn, you will no longer be able to avail of facial\n    recognition services.\n</p>\n<p>\n    c. <strong>Cruise Line Provided Data </strong>such as sailing dates, first\n    name, last name, stateroom number, security photo, date of birth, folio\n    number and booking ID.<strong> </strong>\n</p>\n<p>\n    d. <strong>Contact Data</strong> such as mailing address (should you choose\n    to have products mailed to you), e-mail address (if you have purchased a\n    digital package which will be delivered to you after your cruise),\n    telephone number and billing address.\n</p>\n<p>\n    e. <strong>Transaction Data</strong> such as details about purchases of\n    certain Services.\n</p>\n<p>\n    We also process aggregated data such as statistical or demographic data for\n    various purposes. Aggregated data may be derived from your personal data\n    but is not considered personal data in law as this data does not directly\n    or indirectly reveal your identity. If authorized by your Cruise Line, we\n    will anonymize your personal data so we can process it on an aggregated and\n    anonymous basis.\n</p>\n<p>\n    In some cases, providing your personal data is necessary to enter into a\n    contract with your Cruise Line, or to comply with applicable law. If you do\n    not provide this personal data, the Cruise Line may not be able to perform\n    its contract with you, and we may not be able to perform the Services.\n</p>\n<p>\n    <strong>3. </strong>\n    <strong>When Do We Receive Your Personal Data?</strong>\n</p>\n<p>\n    We may receive the following categories of personal data about you from the\n    following sources:\n</p>\n<p>\n    a. <strong>Photo Event Image </strong>if you have your photograph taken by\n    a TIG photographer;\n</p>\n<p>\nb. <strong>Photo Event Image </strong>and    <strong>Cruise Line Provided Data </strong>if at a Photo Event you swipe\n    your SeaPass card;\n</p>\n<p>\nc. <strong>Photo Event Image</strong>;    <strong>Cruise Line Provided </strong>and <strong>biometric data </strong>\n    if you<strong> </strong>and if each of the guests in your stateroom consent\n    to the use of facial recognition services to identify you in the\n    photographs TIG photographers take at Photo Events;\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\nd. <strong>Photo Event Image</strong>;<strong>Cruise Line Provided Data </strong>and    <strong>Transaction Data</strong> if you purchase any Services via a photo\n    kiosk or Point of Sale onboard a cruise ship. TIG does not process your\n    payment card details;\n</p>"
    },
    {
      "code": "data.privacy.modal.content6",
      "value": "<p>\ne. <strong>Photo Event Image</strong>;<strong>Cruise Line Provided Data</strong> and    <strong>Transaction Data</strong> if we received a query or complaint from\n    you or via your Cruise Line.\n</p>\n<p>\n    <strong>4. </strong>\n    <strong>How We Use Your Personal Data</strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    TIG only processes your personal data on the instructions of your Cruise\n    Line and in accordance with applicable data protection law. We have set out\n    below a description of the ways we use your personal data and the legal\n    grounds for this processing. We have also identified the legitimate\n    interests relied upon where applicable.\n</p>\n<p>\n    a. where you have provided your <strong>explicit consent</strong> for the\n    processing of your biometric data;\n</p>\n<p>\n    b. where it is necessary for the <strong>performance of a contract</strong>\n    between you and the Cruise Line or to take steps to enter into a contract,\n    which may include to:\n</p>\n<p>\n    · take your photograph at one or more Photo Events;\n</p>\n<p>\n    · allocate your photographs to your stateroom photo kiosk account;\n</p>\n<p>\n    · allow you to use a photo kiosk to search for and order photographs;\n</p>\n<p>\n    · fulfil orders for Services, to create and send shore side products,\n    including but not limited to photobooks and personalized photo products\n    such as mugs or phone cases;\n</p>\n<p>\n    · provide customer service support and to deal with queries, complaints and\n    disputes.\n</p>\n<p>\nc. where it is necessary for compliance with a    <strong>legal obligation</strong> to which your Cruise Line is subject;\n</p>\n<p>\nd. where it is necessary for the purpose of the    <strong>legitimate interests</strong> pursued by your Cruise Line or by a\n    third party, which may include:\n</p>\n<p>\n    · to communicate with you, where you have requested such communication;\n</p>\n<p>\n    · to provide you access to the Services including those that have been\n    purchased on your behalf;\n</p>\n<p>\n    · to compile aggregated anonymous information to assist in improving the\n    Services;\n</p>\n<p>\n    · to keep records updated and to answer your queries;\n</p>\n<p>\n    · for running a business and to protect property, assets, staff and others.\n</p>\n<p>\n    <strong>5. </strong>\n    <strong>Data Security</strong>\n</p>\n<p>\n    TIG has implemented and maintains appropriate security measures intended to\n    prevent your personal data from being accidentally lost, used or accessed\n    in an unauthorized way, altered or disclosed. We only process your personal\n    data on the instructions of your Cruise Line, and we are subject to\n    obligations regarding security and confidentiality. Appropriate measures\n    are taken intended to ensure that guest photographs taken onboard by TIG\n    are kept safe and secure, and do not leave the ship unless a passenger\n    purchases a digital product which is delivered digitally after the cruise\n    or a physical product which is delivered to the guest’s contact address\n    after the cruise.\n</p>\n<p>\n    <strong>6. </strong>\n    <strong>Disclosure Of Your Data</strong>\n</p>\n<p>\n    In order to provide the Services on behalf of your Cruise Line we are\n    authorized to disclose your personal data to third parties in the following\n    circumstances:\n</p>\n<p>\n    · to TIG group companies (i.e. a parent company, a subsidiary company\n    and/or a parent of another subsidiary company) who assist us in the\n    provision of and administration of the Services; and\n</p>\n<p>\n    · to third party vendors who assist us in the provision of and\n    administration of the Services (e.g. professional advisors, IT/software\n    systems suppliers and support, data storage, IT developers, photograph\n    processors, courier/delivery service providers, website hosting providers\n    and other service providers).\n</p>\n<p>\n    <strong>7. </strong>\n    <strong>International Data Transfers</strong>\n</p>\n<p>\n    Your personal data may be processed within the European Economic Area\n    (“EEA”) or transferred to, stored in, and accessed from countries outside\n    the EEA in order to fulfil the purposes, and in accordance with the legal\n    grounds, described in this Privacy Notice. For transfers to countries\n    outside the EEA, the data protection regime may be different than in the\n    country in which you are located and will therefore be based on a legally\n    adequate transfer method. Whenever your personal data is transferred out of\n    the EEA, a similar degree of protection is given to it by ensuring at least\n    one of the following is in place:\n</p>"
    },
    {
      "code": "data.privacy.modal.content7",
      "value": "<p>\n    · Where the country has been deemed to provide an adequate level of\n    protection for personal data by the European Commission.\n</p>\n<p>\n    · The use of specific contracts approved by the European Commission which\n    are intended to give personal data the same protection it has in Europe.\n</p>\n<p>\n    · Where service providers are based in the US, if they are part of the\n    EU-U.S. Privacy Shield which requires them to provide similar protection to\n    personal data shared between Europe and the US.\n</p>\n<p>\n    <strong>8. </strong>\n    <strong>Retention Of Personal Data</strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    We comply with your Cruise Line’s requirements for the retention of your\n    personal data. In this regard, your personal data is retained for no longer\n    than is allowed under applicable data protection law and, in any case, for\n    no longer than the purpose(s) for which the personal data was collected or\n    processed exist(s) which is typically (but not always) no longer than one\n    year after you purchase any Service, unless a longer retention period is\n    required by applicable law (such as retention obligations arising under\n    commercial and tax law) or is justified under applicable statutory\n    limitation periods.\n</p>\n<p>\n    Printed hard copy photographs taken onboard the ship by TIG photographers\n    and displayed in the photo gallery, which have not been purchased by the\n    end of the cruise are destroyed at the end of each cruise by the Cruise\n    Line. This does not apply on ships where printed hard copy photographs are\n    only available on demand via the photo kiosk, as only purchased photographs\n    are printed.\n</p>\n<p>\n    Digital photographs taken onboard the ship by TIG photographers are\n    automatically deleted no later than 6 weeks after your cruise ends.\n</p>\n<p>\n    Special occasion and private portraiture photographs are retained for up to\n    one year.\n</p>\n<p>\n    Biometric data generated by the facial recognition service is automatically\n    deleted within 6 weeks after the end of your cruise.\n</p>\n<p>\n    <strong>9. </strong>\n    <strong>Your Data Protection Rights </strong>\n</p>\n<p>\n    <strong></strong>\n</p>"
    },
    {
      "code": "data.privacy.modal.content8",
      "value": "<p>\n    Under certain circumstances, by law you may have the right to:\n</p>\n<ul>\n    <li>\n        <strong>Request access to your personal data.</strong>\n        This enables you to receive a copy of your personal data and to check\n        that is being lawfully processed.\n    </li>\n    <li>\n        <strong>Request correction of your personal data.</strong>\n        This enables you to have any incomplete or inaccurate personal data\n        corrected.\n    </li>\n    <li>\n        <strong>Request erasure of your personal data.</strong>\n        This enables you to request the deletion or removal of personal data\n        where there is no good reason for its continued processing. You also\n        have the right to request the deletion or removal of your personal data\n        where you have exercised your right to object to processing (see\n        below), where your personal data may have been processed unlawfully or\n        where your personal data must be erased in order to comply with local\n        law. It may not always be possible to comply with your request for\n        erasure for specific legal reasons which will be notified to you, if\n        applicable, at the time of your request.\n    </li>\n    <li>\n        <strong>\n            Object to processing of your personal data where legitimate\n            interest\n        </strong>\n        <strong>is relied upon</strong>\n        and there is something about your particular situation which makes you\n        want to object to processing on this ground as you feel it impacts on\n        your fundamental rights and freedoms. You also have the right to object\n        if your personal data is processed for direct marketing purposes. In\n        some cases, the controller may demonstrate compelling legitimate\n        grounds to process your information which override your rights and\n        freedoms.\n    </li>\n    <li>\n        <strong>\n            Request restriction of processing of your personal data.\n        </strong>\n        This enables you to request the suspension of processing of your\n        personal data in the following scenarios: (a) if you want the accuracy\n        of the data established; (b) where use of the personal data is unlawful\n        but you do not want it erased; (c) where you need the personal data\n        retained longer than necessary as you need it to establish, exercise or\n        defend legal claims; or (d) you have objected to the use of your\n        personal data but the controller needs to verify whether it has\n        overriding legitimate grounds to use it.\n    </li>\n    <li>\n        <strong>\n            Request the transfer of your personal data to you or to a third\n            party.\n        </strong>\n        You may request the provision to you, or to a third party you have\n        chosen, of your personal data in a structured, commonly used,\n        machine-readable format. Note that this right only applies to automated\n        information which you initially provided consent for processing or\n        where such personal data is used by the controller to perform a\n        contract with you.\n    </li>\n    <li>\n        <strong>Withdraw consent at any time</strong>\n        if and to the extent consent is relied upon as the legal basis to\n        process your personal data. This will not affect the lawfulness of any\n        processing of your personal data carried out before you withdraw your\n        consent. If you withdraw your consent, we may not be able to provide\n        certain services to you. We will let you know if this is the case at\n        the time you withdraw your consent.\n    </li>\n    <li>\n        <strong>Contacting the data protection supervisory authority</strong>\n        : Data subjects have the right to make a complaint at any time to the\n        applicable data protection supervisory authority. We would, however,\n        appreciate the chance to deal with your concerns before you approach\n        the applicable data protection supervisory authority so please contact\n        us in the first instance using the information listed in Contact Us\n        below.\n    </li>\n</ul>\n<p>\n    You can exercise one or more of your data protection rights by starting a\nsupport ticket with TIG. To do this, please send your request via email to data.protection@image.com.\n    You may also contact TIG by logging a ticket at support.ourcruisephotos.com\n    to exercise your rights described in this section. We will manage your\n    request on behalf of your Cruise Line.\n</p>"
    },
    {
      "code": "data.privacy.modal.content9",
      "value": "<p>\n    <strong>10. </strong>\n    <strong> Changes To This Privacy Notice</strong>\n</p>\n<p>\n    <strong></strong>\n</p>\n<p>\n    This Privacy Notice may be updated from time to time. Whenever this Privacy\n    Notice is updated the new version will signify the date when it was last\n    changed, and it will be made available at the photo kiosks on board your\n    Cruise Line’s ships and on your Cruise Line’s website. Please check for the\n    latest version of this Privacy Notice whenever you avail of any of the\n    Services. By availing of any of the Services after any new Privacy Notice\n    is published you accept the Privacy Notice as modified.\n</p>\n<p>\n    <strong>11. </strong>\n    <strong> Contact Us</strong>\n</p>\n<p>\n    If you have a question or complaint regarding this Privacy Notice or\n    regarding the processing of your personal data, please contact us by one of\n    the following means:\n</p>\n<ul>\n    <li>\n<strong>Email:</strong> data.protection@image.com.\n    </li>\n    <li>\n        <strong>Post:</strong>\n        The Image Group, PO Box 10310, Grand Cayman, Cayman Islands, KY1-1003.\n    </li>\n    <li>\n        <strong>Customer Support:</strong>\n        email at support@ourcruisephotos.com or by telephone on +1 850 250 3423.\n    </li>\n</ul>\n<p>\n    You may also contact your Cruise Line if you have a question or complaint\n    regarding this Privacy Notice or the processing of your personal data,\n    using the contact details specified on your Cruise Line’s privacy notice.\n</p>\n<p>\n    <strong>12. </strong>\n    <strong>Representative</strong>\n</p>\n<p>\n    VeraSafe has been appointed as TIG’s representative in the European Union\n    for data protection matters, pursuant to Article 27 of the GDPR. VeraSafe\n    can be contacted in addition to the contact details provided in section 11\n    above only on matters related to the processing by TIG of personal data\n    which is governed by the GDPR. To make such an inquiry, please contact\n    VeraSafe using this contact form: \n<a target=\"_blank\" href=\"https://www.verasafe.com/privacy-services/contact-article-27-representative\">\n        https://www.verasafe.com/privacy-services/contact-article-27-representative\n    </a>\n</p>\n<p>\n    Alternatively, VeraSafe can be contacted at:\n</p>\n<p>\n    VeraSafe Ireland Ltd\n</p>\n<p>\n    Unit 3D North Point House\n</p>\n<p>\n    North Point Business Park\n</p>\n<p>\n    New Mallow Road\n</p>\n<p>\n    Cork T23AT2P\n</p>\n<p>\n    Ireland\n</p>\n<p>\n    Effective date of last amendment to this Privacy Notice: 27 February 2019\n</p>\n<p>\n    <strong></strong>\n</p>"
    },
    {
      "code": "temporary.address.header",
      "value": "Temporary U.S. address"
    },
    {
      "code": "temporary.address.subheader",
      "value": "To comply with U.S. Customs and Border Protection regulations, you must indicate where you will be staying while in the U.S."
    },
    {
      "code": "footer.brand",
      "value": "Celebrity Cruises, Inc."
    },
    {
      "code": "ssp.stateroom",
      "value": "STATEROOM CATEGORY"
    },
    {
      "code": "header.currency.conversion",
      "value": "Currency Conversion Program"
    },
    {
      "code": "checkbox.currency.conversion",
      "value": "I elect to convert onboard expenses to my credit card’s local currency using a currency conversion service."
    },
    {
      "code": "link.currency.conversion",
      "value": "Learn more."
    },
    {
      "code": "modal.header.currency.conversion",
      "value": "About Celebrity Cruises’ currency conversion service"
    },
    {
      "code": "modal.content.currency.conversion",
      "value": "If your MasterCard or Visa card is billed in any of the following currencies, you may elect to have your onboard expenses charged in the card’s currency, instead of being converted by your credit card issuer: AUD, CAD, CHF, DKK, EUR, HKD, JPY, MXP, NOK, SEK, GBP.\n \nElecting to use Celebrity Cruises’ currency conversion service means that your final folio charges will be based on wholesale exchange rates collected from Bloomberg plus a 3 percent international currency conversion fee, to be determined at the time transactions are charged.\n \nIf you choose not to elect the currency conversion service, your credit card issuer will convert your onboard expenses from USD to your card’s currency, plus any additional service fee per your cardholder agreement.\n \nPlease note that your election to use this service is final."
    },
    {
      "code": "footer.celebrity",
      "value": "Celebrity Cruises, Inc."
    },
    null,
    null,
    null,
    null,
    null,
    null,
    {
      "code": "ssp.celebrity.cruises.title",
      "value": "CELEBRITY CRUISES"
    },
    {
      "code": "ssp.online.check.in.title",
      "value": "ONLINE CHECK-IN"
    },
    {
      "code": "button.curtesy.holds",
      "value": "Courtesy holds"
    },
    {
      "code": "button.past.cruise",
      "value": "Past cruises"
    },
    {
      "code": "header.user.menu.royal.gifts",
      "value": "Royal Gifts"
    },
    {
      "code": "validation.zipcode.invalid",
      "value": "Invalid zip code"
    },
    {
      "code": "ssp.header",
      "value": "Xpress Pass"
    },
    {
      "code": "validation.global.maximum.characters.9",
      "value": "Value must be at most 9 characters."
    },
    {
      "code": "validation.global.maximum.characters.12",
      "value": "Value must be at most 12 characters."
    },
    {
      "code": "validation.global.maximum.characters.14",
      "value": "Value must be at most 14 characters."
    },
    {
      "code": "validation.global.maximum.characters.18",
      "value": "Value must be at most 18 characters."
    },
    {
      "code": "validation.global.maximum.characters.25",
      "value": "Value must be at most 25 characters."
    },
    {
      "code": "validation.global.maximum.characters.30",
      "value": "Value must be at most 30 characters."
    },
    {
      "code": "error.address",
      "value": "Use only letters, numbers, dashes and spaces."
    },
    {
      "code": "tooltip.locked.booking",
      "value": "Check-in for this reservation is currently unavailable, so please try again later."
    },
    {
      "code": "banner.message.locked.booking",
      "value": "Some reservations are currently unavailable."
    },
    {
      "code": "guest.booking.unavailable.label",
      "value": "unavailable"
    },
    {
      "code": "ssp.expedited.arrival.flag",
      "value": "EXPEDITED ARRIVAL"
    },
    {
      "code": "ssp.rcl.logo",
      "value": "Celebrity Cruises"
    },
    {
      "code": "ssp.arrival.appointment.title",
      "value": "ARRIVAL TIME"
    },
    {
      "code": "ssp.class.suite",
      "value": "SUITE"
    },
    {
      "code": "ssp.class.sea",
      "value": "SEA CLASS"
    },
    {
      "code": "ssp.class.sky",
      "value": "SKY CLASS"
    },
    {
      "code": "ssp.class.star",
      "value": "STAR CLASS"
    },
    {
      "code": "ssp.muster.title",
      "value": "MUSTER"
    },
    {
      "code": "ssp.port.title",
      "value": "PORT"
    },
    {
      "code": "ssp.mobile.header1",
      "value": "Check in"
    },
    {
      "code": "ssp.mobile.header3",
      "value": "Sail with the Celebrity Cruises app"
    },
    {
      "code": "ssp.mobile.subheader3",
      "value": "Explore and reserve onboard fun and onshore adventures. You can even board the ship using the app’s mobile Xpress Pass."
    },
    {
      "code": "ssp.mobile.header2",
      "value": "on the Celebrity Cruises App"
    },
    {
      "code": "ssp.gty.text.reprint",
      "value": "REPRINT"
    },
    {
      "code": "ssp.mobile.subheader1",
      "value": "The fastest way to board, plus bypass the counter with our"
    },
    {
      "code": "ssp.mobile.subheader2",
      "value": "boarding program."
    },
    {
      "code": "ssp.mobile.content",
      "value": "Expedited Arrival available to select guests using the Celebrity Cruises app."
    },
    {
      "code": "ssp.gty.text.reprint.assigned",
      "value": "WHEN STATEROOM IS ASSIGNED"
    },
    {
      "code": "qq.cruise.history.modal1",
      "value": "Quick question"
    },
    {
      "code": "header.cruise.history.modal1",
      "value": "Is this your first cruise vacation?"
    },
    {
      "code": "skip.cruise.history.modal1",
      "value": "Skip"
    },
    {
      "code": "header.cruise.history.modal2",
      "value": "Thank you for your info"
    },
    {
      "code": "subheader.cruise.history.modal2",
      "value": "We'll use your response to enhance your future cruise experience."
    },
    {
      "code": "done.cruise.history.modal2",
      "value": "Done"
    },
    {
      "code": "guest.details.remove.selected.guest.label.finish.later",
      "value": "Finish [name]'s check-in later."
    },
    {
      "code": "footer.link.contact.us",
      "value": "Contact us"
    },
    {
      "code": "validation.loyalty.name",
      "value": "The Captain's Club number entered does not match the guest's name and date of birth."
    },
    {
      "code": "email.opt.in1",
      "value": "I understand I can unsubscribe at any time. See our"
    },
    {
      "code": "email.opt.in2",
      "value": "Privacy Policy."
    },
    {
      "code": "error.global.incorrect.information",
      "value": "The Captain's Club number provided is not correct. Please verify the information and try again."
    },
    {
      "code": "error.contracts.not.complete",
      "value": "You must select the check box above to continue."
    },
    {
      "code": "label.reservation.number",
      "value": "Reservation Number"
    },
    {
      "code": "welcome.button.start",
      "value": "GET STARTED"
    },
    {
      "code": "reservation.info.description",
      "value": "Please enter your reservation information."
    },
    {
      "code": "reservation.info.label.departure.date",
      "value": "Departure Date"
    },
    {
      "code": "reservation.info.label.ship",
      "value": "Ship"
    },
    {
      "code": "validation.ctc.contract.minor",
      "value": "You must be age 18 or or older to sign the cruise contract."
    },
    {
      "code": "appointment.arrival.change.warning",
      "value": "Changing the arrival time will require <strong>all party members</strong> to reprint their Xpress Pass"
    },
    {
      "code": "appointment.arrival.validation.select.one",
      "value": "Please select time of arrival"
    },
    {
      "code": "immigration.document.label.drivers.license.state",
      "value": "Driver’s License State"
    },
    {
      "code": "ssp.complete.title",
      "value": "Complete"
    },
    {
      "code": "ssp.photo.upload.to.avoid.title",
      "value": "Please take or upload photo"
    },
    {
      "code": "ssp.photo.upload.avoid.boarding.delay.title",
      "value": "to avoid boarding delays."
    },
    {
      "code": "ssp.security.photo.title",
      "value": "Security Photo"
    },
    {
      "code": "immigration.document.label.birth.certificate.state",
      "value": "Birth Certificate State"
    },
    {
      "code": "label.reservation.title",
      "value": "Reservation"
    },
    {
      "code": "label.guestinfo.address.header",
      "value": "Home address"
    },
    {
      "code": "ssp.reservation.title",
      "value": "Reservation"
    },
    null,
    {
      "code": "label.guestinfo.address.address1",
      "value": "Street address 1"
    },
    {
      "code": "label.guestinfo.address.address2",
      "value": "Street address 2 (optional)"
    },
    {
      "code": "label.guestinfo.address.city",
      "value": "City"
    },
    {
      "code": "label.guestinfo.address.state",
      "value": "State/Province"
    },
    {
      "code": "label.guestinfo.address.country",
      "value": "Country of residence"
    },
    {
      "code": "label.guestinfo.address.zip",
      "value": "ZIP/Postal code"
    },
    {
      "code": "label.pending",
      "value": "Pending"
    },
    {
      "code": "header.user.menu.dashboard",
      "value": "Dashboard"
    },
    {
      "code": "header.boarding.pass.print.page",
      "value": "'s Xpress Pass"
    },
    {
      "code": "header.boarding.pass.print.page.name",
      "value": "[name]'s Xpress Pass"
    },
    {
      "code": "subheader.boarding.pass.print.page",
      "value": "You can change or add more information up to three days before your sail date."
    },
    {
      "code": "print.button.boarding.pass.print.page",
      "value": "Print"
    },
    {
      "code": "header.user.menu.reservations",
      "value": "Upcoming cruises"
    },
    {
      "code": "header.user.menu.profile",
      "value": "Settings"
    },
    {
      "code": "header.user.menu.sign.out",
      "value": "Sign out"
    },
    {
      "code": "lenguage.menu.header",
      "value": "Choose a lenguage"
    },
    {
      "code": "lenguage.menu.english",
      "value": "English"
    },
    {
      "code": "lenguage.menu.spanish",
      "value": "Espanol"
    },
    {
      "code": "lenguage.menu.portuguese",
      "value": "Portugues"
    },
    {
      "code": "header.checkin",
      "value": "Check-in"
    },
    {
      "code": "label.appointment.arrival.description",
      "value": "Your party's arrival time is"
    },
    {
      "code": "guest.summary.contracts.agreed",
      "value": "Agreed"
    },
    {
      "code": "label.view.contract",
      "value": "View contract"
    },
    {
      "code": "label.credit.card.possesive.apostrophe",
      "value": "'s"
    },
    {
      "code": "immigration.document.label.address",
      "value": "Temporary U.S. address"
    },
    {
      "code": "immigration.document.tootip.address",
      "value": "U.S. Customs and Border Protection requires that you provide an address."
    },
    {
      "code": "button.print.contracts",
      "value": "Print"
    },
    {
      "code": "title.confimation",
      "value": "All set"
    },
    {
      "code": "label.more.guests",
      "value": "Check in more guests"
    },
    {
      "code": "label.dashboard",
      "value": "Go to My account"
    },
    {
      "code": "button.dashboard",
      "value": "Go to My account"
    },
    {
      "code": "photo.label.editphoto",
      "value": "Edit photo"
    },
    {
      "code": "photo.label.addphoto",
      "value": "Add photo"
    },
    {
      "code": "photo.modals.header",
      "value": "[name]'s photo"
    },
    {
      "code": "photo.requirementsmodal.req1",
      "value": "Photo must reflect the guest's current appearance and be taken in front of a white or off-white background."
    },
    {
      "code": "photo.requirementsmodal.req2",
      "value": "Expression should be neutral or a natural smile with both eyes open."
    },
    {
      "code": "photo.requirementsmodal.req3",
      "value": "Position face and shoulders centered and straight to the camera."
    },
    {
      "code": "photo.requirementsmodal.req4",
      "value": "No hat, head covering, or sunglasses may be worn."
    },
    {
      "code": "photo.takeuploadmodal.opencamera",
      "value": "Open camera"
    },
    {
      "code": "photo.takeuploadmodal.error.imagetoolarge",
      "value": "The image you've uploaded is too large. Your image must be 1MB or less."
    },
    {
      "code": "photo.uploadmodal.differentphoto",
      "value": "Use a different photo"
    },
    {
      "code": "photo.modals.savephoto",
      "value": "Save photo"
    },
    {
      "code": "photo.cameramodal.takephoto",
      "value": "Take photo"
    },
    {
      "code": "guest.details.remove.selected.guest.label.line1",
      "value": "Missing some info?"
    },
    {
      "code": "guest.details.remove.selected.guest.label.finish",
      "value": "Finish"
    },
    {
      "code": "guest.details.remove.selected.guest.label.checkin",
      "value": "'s check-in later."
    },
    {
      "code": "button.reprint",
      "value": "Reprint"
    },
    {
      "code": "month.jan",
      "value": "January"
    },
    {
      "code": "month.feb",
      "value": "February"
    },
    {
      "code": "month.mar",
      "value": "March"
    },
    {
      "code": "month.apr",
      "value": "April"
    },
    {
      "code": "month.may",
      "value": "May"
    },
    {
      "code": "month.jun",
      "value": "June"
    },
    {
      "code": "month.jul",
      "value": "July"
    },
    {
      "code": "month.aug",
      "value": "August"
    },
    {
      "code": "month.sep",
      "value": "September"
    },
    {
      "code": "month.oct",
      "value": "October"
    },
    {
      "code": "month.nov",
      "value": "November"
    },
    {
      "code": "month.dec",
      "value": "December"
    },
    {
      "code": "gender.sex.male",
      "value": "Male"
    },
    {
      "code": "gender.sex.female",
      "value": "Female"
    },
    {
      "code": "ctc.content.international",
      "value": "As advised at the time of making your booking, this booking is subject to the booking conditions of your local booking office. If you have booked via a travel agency, additional terms may apply. We recommend you review the booking conditions prior to travel as this contains useful information."
    },
    {
      "code": "button.email.contract",
      "value": "Email"
    },
    {
      "code": "ctc.email.header",
      "value": "Email Cruise Ticket Contract"
    },
    {
      "code": "ctc.email.label",
      "value": "Email my contract to:"
    },
    {
      "code": "ctc.international.content",
      "value": "As advised at the time of making your booking, this booking is subject to the booking conditions of your local booking office . If you have booked via a travel agency, additional terms may apply. We recommend you review the booking conditions prior to travel as this contains useful information."
    },
    {
      "code": "button.save",
      "value": "Save card"
    },
    {
      "code": "label.first.name",
      "value": "First name"
    },
    {
      "code": "label.last.name",
      "value": "Last name"
    },
    {
      "code": "label.phone",
      "value": "Phone"
    },
    {
      "code": "label.email",
      "value": "Email"
    },
    {
      "code": "button.help",
      "value": "FAQ"
    },
    {
      "code": "button.about.us",
      "value": "About us"
    },
    {
      "code": "button.privacy",
      "value": "Privacy"
    },
    {
      "code": "button.legal",
      "value": "Legal"
    },
    {
      "code": "button.site.map",
      "value": "Site map"
    },
    {
      "code": "button.skip",
      "value": "Skip to main content"
    },
    {
      "code": "label.suffix",
      "value": "Suffix (optional)"
    },
    {
      "code": "name.tooltip",
      "value": "Contact Celebrity Cruises to edit this information."
    },
    {
      "code": "ctc.warning",
      "value": "There must be at least one adult age 21 or older in your party in order to sail."
    },
    {
      "code": "marital.status.tooltip",
      "value": "Guests under age 21 must travel with a guest age 21 or older. Married guests under age 21 must present a marriage certificate at the port terminal."
    },
    {
      "code": "marital.status.tooltip2",
      "value": "Guests under age 21 must travel with a guest age 21 or older."
    },
    null,
    {
      "code": "landing.page.title.select.guests",
      "value": "Who's checking in?"
    },
    {
      "code": "landing.page.subtitle.select.guests",
      "value": "Guests who enter passport information and take security photos during check-in board faster."
    },
    {
      "code": "label.boarding.pass",
      "value": "View Xpress Pass"
    },
    {
      "code": "banner.invalidation.landing.page",
      "value": "Account changes have been made by you or a member of your party. Please sign your updated Cruise Ticket Contract and print your Xpress Pass."
    },
    {
      "code": "banner.invalidation.guest.details",
      "value": "Account changes have been made by you or a member of your party. Please sign your updated Cruise Ticket Contract and print your Xpress Pass."
    },
    {
      "code": "header.invalidation.modal",
      "value": "Something's changed"
    },
    {
      "code": "subheader.invalidation.modal",
      "value": "If you continue with account changes, please be sure to sign your updated Cruise Ticket Contract and re-print your Xpress Pass."
    },
    {
      "code": "proceed.button.invalidation.modal",
      "value": "Continue"
    },
    {
      "code": "return.button.invalidation.modal",
      "value": "Cancel"
    },
    {
      "code": "tool.tip.reprint",
      "value": "Your Xpress Pass has been updated. You will need to reprint your pass."
    },
    {
      "code": "tool.tip.luggage.tag.pending",
      "value": "This guest is checked in. Their luggage tag is still processing, so come back later to print a copy."
    },
    {
      "code": "tool.tip.boarding.pass.pending",
      "value": "This guest is checked in. Their Xpress Pass is still processing, so come back later to print a copy."
    },
    {
      "code": "personal.details.header",
      "value": "Guest information"
    },
    {
      "code": "personal.details.contact.us",
      "value": "Contact us"
    },
    {
      "code": "personal.details.update.info",
      "value": "Need to update your information?"
    },        
    {
      "code": "guest.info.saving.modal.header",
      "value": "Let’s finish this off"
    },
    {
      "code": "guest.info.saving.modal.subtitle",
      "value": "Complete check-in now and all that's left is the packing."
    },
    {
      "code": "guest.info.saving.validation.message",
      "value": "Complete all information for every guest in order to continue to the next section."
    },
    {
      "code": "guest.info.saving.modal.yes",
      "value": "Leave check-in"
    },
    {
      "code": "guest.info.saving.modal.no",
      "value": "Continue check-in"
    },
    null,
    {
      "code": "label.middle.name",
      "value": "Middle name (optional)"
    },
    {
      "code": "label.middle.name.check",
      "value": "No middle name"
    },
    {
      "code": "button.no",
      "value": "No"
    },
    {
      "code": "label.date.of.birth",
      "value": "Date of birth"
    },
    {
      "code": "label.gender",
      "value": "Gender"
    },
    {
      "code": "label.marital.status",
      "value": "Marital status"
    },
    {
      "code": "personal.details.header",
      "value": "Guest information"
    },
    {
      "code": "address.select.country.of.residence",
      "value": "Country of residence"
    },
    {
      "code": "address.label.address",
      "value": "Address"
    },
    {
      "code": "address.label.zip",
      "value": "ZIP code"
    },
    {
      "code": "address.label.city",
      "value": "City"
    },
    {
      "code": "address.label.state",
      "value": "State"
    },
    {
      "code": "contact.info.header.title",
      "value": "Contact information"
    },
    {
      "code": "emergency.contact.header",
      "value": "Emergency contact"
    },
    {
      "code": "label.name",
      "value": "First name"
    },
    {
      "code": "emergency.contact.header.description",
      "value": "Must be family or friend not sailing with you."
    },
    {
      "code": "immigration.header",
      "value": "Travel documentation"
    },
    {
      "code": "immigration.label.country.of.citizenship",
      "value": "Country of citizenship"
    },
    {
      "code": "immigration.header",
      "value": "Travel documentation"
    },
    null,
    {
      "code": "immigration.document.label.document.type",
      "value": "Document type"
    },
    {
      "code": "immigration.document.label.document.number",
      "value": "Document number"
    },
    {
      "code": "immigration.document.label.expiration.date",
      "value": "Expiration date"
    },
    {
      "code": "immigration.document.label.photo.id.issuing.state",
      "value": "Photo ID issuing state"
    },
    {
      "code": "immigration.document.label.state.id.issuing.state",
      "value": "State ID issuing state"
    },
    {
      "code": "immigration.document.label.country.of.birth",
      "value": "Country of birth"
    },
    {
      "code": "immigration.header",
      "value": "Travel documents"
    },
    {
      "code": "immigration.international.flow.question",
      "value": "Will you be in the U.S. for longer than 8 hours after departing the ship?"
    },
    {
      "code": "photo.header",
      "value": "Security photo"
    },
    null,
    {
      "code": "photo.label.upload.mobile",
      "value": "Upload photo"
    },
    {
      "code": "photo.description.upload",
      "value": "No other person, including parents of infants, may appear in the photo."
    },
    {
      "code": "photo.description.error",
      "value": "Hmm, we can't detect a camera"
    },
    {
      "code": "photo.button.retake",
      "value": "Retake"
    },
    {
      "code": "photo.label.drop.upload.desktop",
      "value": "Drop your picture here or click to upload."
    },
    {
      "code": "expense.account.header",
      "value": "Onboard expense account"
    },
    {
      "code": "expense.account.header.description",
      "value": "Set up your onboard expense account."
    },
    {
      "code": "expense.account.change.card",
      "value": "Select a different card"
    },
    {
      "code": "expense.account.add.card",
      "value": "Add a card"
    },
    {
      "code": "expense.account.title.payment.type.credit.card",
      "value": "Credit card"
    },
    {
      "code": "expense.account.title.payment.type.none",
      "value": "No charging privileges"
    },
    {
      "code": "expense.account.label.credit.card.number",
      "value": "Card number"
    },
    {
      "code": "expense.account.label.expiration.date",
      "value": "Expiration date"
    },
    {
      "code": "expense.account.label.security.code",
      "value": "Security code"
    },
    {
      "code": "expense.account.label.zip.code",
      "value": "Zip Code"
    },
    {
      "code": "expense.account.label.name",
      "value": "Name as shown on card"
    },
    {
      "code": "expense.account.title.add.guest",
      "value": "Add guests"
    },
    {
      "code": "expense.account.inline.warning.onboard.expenses.incomplete",
      "value": "You haven't finished setting up your Onboard Expense account."
    },
    {
      "code": "expense.account.header.credit.card.authorization",
      "value": "Onboard expense contract"
    },
    {
      "code": "contracts.label.expand",
      "value": "Expand full text"
    },
    {
      "code": "expense.account.description.credit.card.authorization",
      "value": ", would like to pay for the guests in the following reservation and grant them authority to sign on to this account. If I set up with a credit card, I also affirm that I have read and understand the credit card notice above"
    },
    {
      "code": "expense.account.title.credit.card.authorization.terms",
      "value": "You may change the saved credit card in"
    },
    {
      "code": "expense.account.title.credit.card.authorization.terms.1",
      "value": "onboard expenses"
    },
    {
      "code": "expense.account.button.add.more.guests.yes",
      "value": "Yes"
    },
    {
      "code": "ctc.header",
      "value": "Cruise ticket contract"
    },
    {
      "code": "ctc.header.description",
      "value": "Don’t want to accept for everyone? Return to your"
    },
    {
      "code": "ctc.international.description",
      "value": "Your booking with us is bound by the terms and conditions of the booking office through whom your reservation was made. A copy of these terms and conditions can be found on each local market website, or from your travel agent."
    },
    {
      "code": "appointment.arrival.header",
      "value": "When would you like to join us?"
    },
    {
      "code": "appointment.arrival.change.link",
      "value": "Select a different time"
    },
    {
      "code": "ssp.header1",
      "value": "Xpress Pass"
    },
    {
      "code": "button.submit",
      "value": "Send"
    },
    {
      "code": "button.close",
      "value": "Close"
    },
    {
      "code": "button.back",
      "value": "Back"
    },
    {
      "code": "label.luggage.tags",
      "value": "View luggage tags"
    },
    {
      "code": "button.continue",
      "value": "Continue"
    },
    {
      "code": "button.complete.check.in",
      "value": "Complete check-in"
    },
    {
      "code": "button.return.to.guest.list",
      "value": "Return to guest list"
    },
    {
      "code": "ctc.header.description2",
      "value": "guest party."
    },
    {
      "code": "button.edit",
      "value": "Edit"
    },
    {
      "code": "time.out.session.title",
      "value": "Oops, your session has timed out."
    },
    {
      "code": "time.out.button.log.out",
      "value": "Leave check-in"
    },
    {
      "code": "validation.ctc.minor.parent.must.sign.subtitle",
      "value": "Please have an adult in your party complete Check-In"
    },
    {
      "code": "validation.expense.account.card.name",
      "value": "Invalid cardholder name. Letters only. No special characters allowed."
    },
    {
      "code": "validation.expense.account.card.expiration.date",
      "value": "Your credit card must be valid through the end of your cruise vacation."
    },
    {
      "code": "validation.expense.account.full.card.number",
      "value": "Please enter a valid credit card number"
    },
    {
      "code": "validation.immigration.passport.expiration.date",
      "value": "Your travel document must be valid for the entire length of the cruise"
    },
    {
      "code": "validation.immigration.passport.expiration.date.six.months",
      "value": "Celebrity Cruises strongly recommends that all guests travel with a document that is valid for at least 6 months beyond the end of the cruise."
    },
    {
      "code": "validation.immigration.document.number.minimum.characters",
      "value": "Document must be at least 12 characters."
    },
    {
      "code": "validation.immigration.document.number.already.entered",
      "value": "Document number has already been entered for another guest. Please review."
    },
    {
      "code": "validation.immigration.inline.5.characters",
      "value": "Value must be at least 5 characters"
    },
    {
      "code": "validation.immigration.inline.no.special.characters",
      "value": "No special characters allowed"
    },
    {
      "code": "validation.immigration.inline.valid.document.number",
      "value": "Please enter a valid document number"
    },
    {
      "code": "error.global.required.info",
      "value": "The information is required."
    },
    {
      "code": "validation.global.characters1",
      "value": "Use only letters, hyphens, apostrophes and spaces"
    },
    {
      "code": "validation.global.characters.numbers.only",
      "value": "Use numbers only."
    },
    {
      "code": "error.global.valid.value",
      "value": "Please enter a valid value."
    },
    {
      "code": "validation.global.value.must.be.selected",
      "value": "A value must be selected."
    },
    {
      "code": "validation.global.email.format",
      "value": "Please enter a valid email address with format xx@xxx.xx"
    },
    {
      "code": "validation.global.minimum.characters.6",
      "value": "Value must be at least 6 characters."
    },
    {
      "code": "validation.global.minimum.characters.4",
      "value": "Value must be at least 4 characters."
    },
    {
      "code": "validation.global.maximum.characters.19",
      "value": "Value must be at most 19 characters."
    },
    {
      "code": "validation.global.maximum.characters.60",
      "value": "Value must be at most 60 characters."
    },
    {
      "code": "validation.global.maximum.characters.29",
      "value": "Value must be at most 29 characters."
    },
    {
      "code": "validation.global.maximum.characters.19",
      "value": "Value must be at most 19 characters."
    },
    {
      "code": "validation.global.maximum.characters",
      "value": "Maximum characters reached."
    },
    {
      "code": "validation.address.characters",
      "value": "Use numbers, letters, dashes, #, dots and spaces."
    },
    {
      "code": "validation.address.city.characters",
      "value": "Use letters and spaces only."
    },
    {
      "code": "validation.address.postal.characters",
      "value": "Use letters, numbers, dashes and spaces only"
    },
    {
      "code": "validation.global.phone",
      "value": "Use only numbers, spaces, dashes and plus sign."
    },
    {
      "code": "validation.global.valuemustbeselected",
      "value": "A value must be selected"
    },
    {
      "code": "validation.personal.details.dob.after.today",
      "value": "Invalid Date of Birth"
    },
    {
      "code": "validation.invalid.date",
      "value": "Invalid Date"
    },
    {
      "code": "validation.invalid.date.6months",
      "value": "Guest must be at least 6 months old as of the first day of the Cruise"
    },
    {
      "code": "validation.global.incomplete.personal.information",
      "value": "Please complete the personal information of the remaining guests for whom you have granted the payment method to proceed further."
    },
    {
      "code": "validation.global.ssp.checkin.complete.minor",
      "value": "has already checked-in. Any changes you make to the information below will require Guest and associated Guests' Xpress Pass to be reprinted."
    },
    {
      "code": "validation.reservation.retrieval.past.sailing.date",
      "value": "Oops. This ship has already sailed."
    },
    {
      "code": "error.technical.difficulties.header",
      "value": "Information is currently not available. Please try again later."
    },
    {
      "code": "error.technical.difficulties",
      "value": "Information is currently not available. Please try again later."
    },
    {
      "code": "error.technical.difficulties.subheader",
      "value": "Please check back in a few and/or refresh your browser."
    },
    {
      "code": "error.technical.difficulties.button.dashboard",
      "value": "Back to My account"
    },
    {
      "code": "error.technical.difficulties.button.try.again",
      "value": "Try again"
    },
    {
      "code": "ssp.boarding.time.title",
      "value": "Check-in Time"
    },
    {
      "code": "error.check.in.closed.header",
      "value": "Check-in is now closed"
    },
    {
      "code": "server.error.header",
      "value": "Sorry, we hit a snag."
    },
    {
      "code": "server.error.subheader",
      "value": "We're unable to complete your request. Please try again later."
    },
    {
      "code": "error.check.in.closed.subtitle",
      "value": "Below are the guests who have completed check-in. Any remaining guests will need to check in at the pier on embarkation day. Bon Voyage!"
    },
    {
      "code": "title.day",
      "value": "Day"
    },
    {
      "code": "title.month",
      "value": "Month"
    },
    {
      "code": "title.year",
      "value": "Year"
    },
    {
      "code": "ssp.stateroom.inside",
      "value": "Inside Stateroom"
    },
    {
      "code": "ssp.stateroom.oceanview",
      "value": "Ocean View Stateroom"
    },
    {
      "code": "ssp.stateroom.deluxoceanview",
      "value": "Deluxe Ocean View Stateroom"
    },
    {
      "code": "ssp.stateroom.veranda",
      "value": "Veranda Stateroom"
    },
    {
      "code": "ssp.class.aqua",
      "value": "AquaClass"
    },
    {
      "code": "ssp.class.suite",
      "value": "SUITE"
    },
    {
      "code": "ssp.class.concierge",
      "value": "Concierge Class"
    },
    {
      "code": "ssp.value.no.applicable",
      "value": "NA"
    },
    {
      "code": "ssp.onboard.expense.account.title",
      "value": "Onboard expense account"
    },
    {
      "code": "ssp.value.stateroom.gty",
      "value": "GTY"
    },
    {
      "code": "expense.account.label.credit.card.number.limited",
      "value": "Last 4 digits of card"
    },
    {
      "code": "ctc.guest.agreement",
      "value": ", have read, understand and accept the cruise ticket contract terms. I affirm that (a) each guest whom I am checking in has also read, understands and accepts the applicable cruise ticket contract terms and (b) I am legally authorized to accept the cruise ticket contract terms on behalf of each guest I am checking in."
    },
    {
      "code": "label.agreement.i",
      "value": "I,"
    },
    {
      "code": "expense.account.card.type",
      "value": "Card type"
    },
    {
      "code": "message.modal.leaving.olci.header",
      "value": "You're almost there"
    },
    {
      "code": "message.modal.leaving.olci.subheader",
      "value": "Are you sure you want to leave check-in? All information will be saved."
    },
    {
      "code": "button.cancel",
      "value": "Cancel"
    },
    {
      "code": "validation.ctc.contract.signed",
      "value": "Agreed by"
    },
    {
      "code": "time.out.message.15.minutes.inactivity",
      "value": "If no action is taken, you will be logged out in"
    },
    {
      "code": "time.out.message.15.minutes.inactivity2",
      "value": "minutes and"
    },
    {
      "code": "time.out.header.still.there.question",
      "value": "Your session is about to expire."
    },
    {
      "code": "time.out.message.minute.inactivity",
      "value": "minute and"
    },
    {
      "code": "time.out.message.15.minutes.inactivity3",
      "value": "seconds."
    },
    {
      "code": "time.out.label.extend.time",
      "value": "Stay signed in"
    },
    {
      "code": "expense.account.credit.card.terms",
      "value": "Credit card information is required in order to set up an Onboard Expense Account for the guest(s) identified herein. There will not be any charges made or authorizations obtained on the credit card prior to sailing. The Cardholder named authorizes the cruise line to charge the credit card account indicated for any outstanding balance on the Onboard Expense Account before the end of the cruise and agrees to be personally liable for such outstanding balance."
    },
    {
      "code": "ssp.name.title",
      "value": "Name"
    },
    {
      "code": "ssp.ship.title",
      "value": "Ship"
    },
    {
      "code": "ssp.sailing.title",
      "value": "Sailing"
    },
    {
      "code": "ssp.departure.port.title",
      "value": "Departure Port"
    },
    {
      "code": "ssp.reservation.number.title",
      "value": "Reservation Number"
    },
    {
      "code": "ssp.muster.station.title",
      "value": "Muster Station"
    },
    {
      "code": "ssp.authorized.by.title",
      "value": "Authorized By"
    },
    {
      "code": "ssp.frictionless.title",
      "value": "ELIGIBLE FOR EXPEDITED ARRIVAL TRIAL"
    },
    {
      "code": "ssp.frictionless.look.for.signage",
      "value": "LOOK FOR SIGNAGE AT THE PORT"
    },
    {
      "code": "ssp.royal.caribbean.title",
      "value": "Celebrity Cruises"
    },
    {
      "code": "ssp.fold.here.title",
      "value": "FOLD HERE"
    },
    {
      "code": "ssp.deck.title",
      "value": "Deck"
    },
    {
      "code": "boarding.pass.terminal.title",
      "value": "TERMINAL"
    },
    {
      "code": "ssp.stateroom.title",
      "value": "Stateroom"
    },
    {
      "code": "spp.cash.title",
      "value": "Cash account"
    },
    {
      "code": "user.menu.label.my.account",
      "value": "My account"
    },
    {
      "code": "progress.bar.guest",
      "value": "Guest"
    },
    {
      "code": "progress.bar.onboard.expenses",
      "value": "Expenses"
    },
    {
      "code": "progress.bar.contracts",
      "value": "Contracts"
    },
    {
      "code": "progress.bar.arrival",
      "value": "Arrival"
    },
    {
      "code": "dynamic.document.type.p",
      "value": "Passport"
    },
    {
      "code": "dynamic.document.type.a",
      "value": "Alien resident card"
    },
    {
      "code": "dynamic.document.type.u",
      "value": "Australian Driver s License"
    },
    {
      "code": "dynamic.document.type.r",
      "value": "Birth Abroad Certificate"
    },
    {
      "code": "dynamic.document.type.b",
      "value": "Birth Certificate"
    },
    {
      "code": "dynamic.document.type.l",
      "value": "Enhanced Driver s License"
    },
    {
      "code": "dynamic.document.type.z",
      "value": "Fast Card"
    },
    {
      "code": "dynamic.document.type.c",
      "value": "Naturalization Certificate"
    },
    {
      "code": "dynamic.document.type.x",
      "value": "Nexus Card"
    },
    {
      "code": "dynamic.document.type.i",
      "value": "Passport Card"
    },
    {
      "code": "dynamic.document.type.g",
      "value": "Re Entry Document"
    },
    {
      "code": "dynamic.document.type.y",
      "value": "Refugee Travel Document"
    },
    {
      "code": "dynamic.document.type.e",
      "value": "Sentri Card"
    },
    {
      "code": "dynamic.document.type.d",
      "value": "Driver s License"
    },
    {
      "code": "dynamic.document.type.m",
      "value": "Military ID Card"
    },
    {
      "code": "dynamic.document.type.n",
      "value": "No photo document required"
    },
    {
      "code": "dynamic.document.type.t",
      "value": "State ID Card"
    },
    {
      "code": "dynamic.document.type.s",
      "value": "Student ID Card"
    },
    {
      "code": "dynamic.country.afg",
      "value": "Afghanistan"
    },
    {
      "code": "dynamic.country.alb",
      "value": "Albania"
    },
    {
      "code": "dynamic.country.dza",
      "value": "Algeria"
    },
    {
      "code": "dynamic.country.asm",
      "value": "American Samoa"
    },
    {
      "code": "dynamic.country.and",
      "value": "Andorra"
    },
    {
      "code": "dynamic.country.ago",
      "value": "Angola"
    },
    {
      "code": "dynamic.country.aia",
      "value": "Anguilla"
    },
    {
      "code": "dynamic.country.ata",
      "value": "Antarctica"
    },
    {
      "code": "dynamic.country.atg",
      "value": "Antigua And Barbuda"
    },
    {
      "code": "dynamic.country.arg",
      "value": "Argentina"
    },
    {
      "code": "dynamic.country.arm",
      "value": "Armenia"
    },
    {
      "code": "dynamic.country.abw",
      "value": "Aruba"
    },
    {
      "code": "dynamic.country.aus",
      "value": "Australia"
    },
    {
      "code": "dynamic.country.aut",
      "value": "Austria"
    },
    {
      "code": "dynamic.country.aze",
      "value": "Azerbaijan"
    },
    {
      "code": "dynamic.country.bhs",
      "value": "Bahamas"
    },
    {
      "code": "dynamic.country.bhr",
      "value": "Bahrain"
    },
    {
      "code": "dynamic.country.bgd",
      "value": "Bangladesh"
    },
    {
      "code": "dynamic.country.brb",
      "value": "Barbados"
    },
    {
      "code": "dynamic.country.blr",
      "value": "Belarus"
    },
    {
      "code": "dynamic.country.bel",
      "value": "Belgium"
    },
    {
      "code": "dynamic.country.blz",
      "value": "Belize"
    },
    {
      "code": "dynamic.country.ben",
      "value": "Benin"
    },
    {
      "code": "dynamic.country.bmu",
      "value": "Bermuda"
    },
    {
      "code": "dynamic.country.btn",
      "value": "Bhutan"
    },
    {
      "code": "dynamic.country.bol",
      "value": "Bolivia"
    },
    {
      "code": "dynamic.country.bon",
      "value": "Bonaire"
    },
    {
      "code": "dynamic.country.bih",
      "value": "Bosnia And Herzegovina"
    },
    {
      "code": "dynamic.country.bwa",
      "value": "Botswana"
    },
    {
      "code": "dynamic.country.bvt",
      "value": "Bouvet Island"
    },
    {
      "code": "dynamic.country.bra",
      "value": "Brazil"
    },
    {
      "code": "dynamic.country.iot",
      "value": "British Indian Ocean"
    },
    {
      "code": "dynamic.country.brn",
      "value": "Brunei Darussalam"
    },
    {
      "code": "dynamic.country.bgr",
      "value": "Bulgaria"
    },
    {
      "code": "dynamic.country.bfa",
      "value": "Burkina Faso"
    },
    {
      "code": "dynamic.country.bur",
      "value": "Burma"
    },
    {
      "code": "dynamic.country.bdi",
      "value": "Burundi"
    },
    {
      "code": "dynamic.country.khm",
      "value": "Cambodia"
    },
    {
      "code": "dynamic.country.cmr",
      "value": "Cameroon"
    },
    {
      "code": "dynamic.country.can",
      "value": "Canada"
    },
    {
      "code": "dynamic.country.cpv",
      "value": "Cape Verde Islands"
    },
    {
      "code": "dynamic.country.cym",
      "value": "Cayman Islands"
    },
    {
      "code": "dynamic.country.caf",
      "value": "Central African Republic"
    },
    {
      "code": "dynamic.country.tcd",
      "value": "Chad Republic"
    },
    {
      "code": "dynamic.country.chl",
      "value": "Chile"
    },
    {
      "code": "dynamic.country.chn",
      "value": "China"
    },
    {
      "code": "dynamic.country.cxr",
      "value": "Christmas Island"
    },
    {
      "code": "dynamic.country.cck",
      "value": "Cocos Keeling Island"
    },
    {
      "code": "dynamic.country.col",
      "value": "Colombia"
    },
    {
      "code": "dynamic.country.com",
      "value": "Comoros"
    },
    {
      "code": "dynamic.country.cok",
      "value": "Cook Islands"
    },
    {
      "code": "dynamic.country.cri",
      "value": "Costa Rica"
    },
    {
      "code": "dynamic.country.civ",
      "value": "Cote Divoire"
    },
    {
      "code": "dynamic.country.hrv",
      "value": "Croatia"
    },
    {
      "code": "dynamic.country.cub",
      "value": "Cuba"
    },
    {
      "code": "dynamic.country.cur",
      "value": "Curacao"
    },
    {
      "code": "dynamic.country.cyp",
      "value": "Cyprus"
    },
    {
      "code": "dynamic.country.cze",
      "value": "Czech Republic"
    },
    {
      "code": "dynamic.country.dnk",
      "value": "Denmark"
    },
    {
      "code": "dynamic.country.dji",
      "value": "Djibouti"
    },
    {
      "code": "dynamic.country.dma",
      "value": "Dominica"
    },
    {
      "code": "dynamic.country.dom",
      "value": "Dominican Republic"
    },
    {
      "code": "dynamic.country.uae",
      "value": "Dubai"
    },
    {
      "code": "dynamic.country.tmp",
      "value": "East Timor"
    },
    {
      "code": "dynamic.country.ecu",
      "value": "Ecuador"
    },
    {
      "code": "dynamic.country.egy",
      "value": "Egypt"
    },
    {
      "code": "dynamic.country.slv",
      "value": "El Salvador"
    },
    {
      "code": "dynamic.country.gnq",
      "value": "Equatorial Guinea"
    },
    {
      "code": "dynamic.country.eri",
      "value": "Eritrea"
    },
    {
      "code": "dynamic.country.est",
      "value": "Estonia"
    },
    {
      "code": "dynamic.country.eth",
      "value": "Ethiopia"
    },
    {
      "code": "dynamic.country.fro",
      "value": "Faeroe Islands"
    },
    {
      "code": "dynamic.country.flk",
      "value": "Falkland Islands"
    },
    {
      "code": "dynamic.country.fji",
      "value": "Fiji Islands"
    },
    {
      "code": "dynamic.country.fin",
      "value": "Finland"
    },
    {
      "code": "dynamic.country.fra",
      "value": "France"
    },
    {
      "code": "dynamic.country.guf",
      "value": "French Guiana"
    },
    {
      "code": "dynamic.country.pyf",
      "value": "French Polynesia"
    },
    {
      "code": "dynamic.country.atf",
      "value": "French South. Territories"
    },
    {
      "code": "dynamic.country.gab",
      "value": "Gabon"
    },
    {
      "code": "dynamic.country.gmb",
      "value": "Gambia"
    },
    {
      "code": "dynamic.country.geo",
      "value": "Georgia"
    },
    {
      "code": "dynamic.country.deu",
      "value": "Germany"
    },
    {
      "code": "dynamic.country.gha",
      "value": "Ghana"
    },
    {
      "code": "dynamic.country.gib",
      "value": "Gibraltar"
    },
    {
      "code": "dynamic.country.grc",
      "value": "Greece"
    },
    {
      "code": "dynamic.country.grl",
      "value": "Greenland"
    },
    {
      "code": "dynamic.country.grd",
      "value": "Grenada"
    },
    {
      "code": "dynamic.country.glp",
      "value": "Guadeloupe"
    },
    {
      "code": "dynamic.country.gum",
      "value": "Guam"
    },
    {
      "code": "dynamic.country.gtm",
      "value": "Guatemala"
    },
    {
      "code": "dynamic.country.gin",
      "value": "Guinea"
    },
    {
      "code": "dynamic.country.gnb",
      "value": "Guinea Bissau"
    },
    {
      "code": "dynamic.country.guy",
      "value": "Guyana"
    },
    {
      "code": "dynamic.country.hti",
      "value": "Haiti"
    },
    {
      "code": "dynamic.country.hmd",
      "value": "Heard and McDonald Island"
    },
    {
      "code": "dynamic.country.hnd",
      "value": "Honduras"
    },
    {
      "code": "dynamic.country.hkg",
      "value": "Hong Kong"
    },
    {
      "code": "dynamic.country.hun",
      "value": "Hungary"
    },
    {
      "code": "dynamic.country.isl",
      "value": "Iceland"
    },
    {
      "code": "dynamic.country.ind",
      "value": "India"
    },
    {
      "code": "dynamic.country.idn",
      "value": "Indonesia"
    },
    {
      "code": "dynamic.country.irn",
      "value": "Iran"
    },
    {
      "code": "dynamic.country.irq",
      "value": "Iraq"
    },
    {
      "code": "dynamic.country.irl",
      "value": "Ireland"
    },
    {
      "code": "dynamic.country.isr",
      "value": "Israel"
    },
    {
      "code": "dynamic.country.ita",
      "value": "Italy"
    },
    {
      "code": "dynamic.country.jam",
      "value": "Jamaica"
    },
    {
      "code": "dynamic.country.jpn",
      "value": "Japan"
    },
    {
      "code": "dynamic.country.jor",
      "value": "Jordan"
    },
    {
      "code": "dynamic.country.kaz",
      "value": "Kazakhstan"
    },
    {
      "code": "dynamic.country.ken",
      "value": "Kenya"
    },
    {
      "code": "dynamic.country.kir",
      "value": "Kiribati"
    },
    {
      "code": "dynamic.country.kwt",
      "value": "Kuwait"
    },
    {
      "code": "dynamic.country.kgz",
      "value": "Kyrgyzstan"
    },
    {
      "code": "dynamic.country.lao",
      "value": "Laos"
    },
    {
      "code": "dynamic.country.lva",
      "value": "Latvia"
    },
    {
      "code": "dynamic.country.lbn",
      "value": "Lebanon"
    },
    {
      "code": "dynamic.country.lso",
      "value": "Lesotho"
    },
    {
      "code": "dynamic.country.lbr",
      "value": "Liberia"
    },
    {
      "code": "dynamic.country.lby",
      "value": "Libya"
    },
    {
      "code": "dynamic.country.lie",
      "value": "Liechtenstein"
    },
    {
      "code": "dynamic.country.ltu",
      "value": "Lithuania"
    },
    {
      "code": "dynamic.country.lux",
      "value": "Luxembourg"
    },
    {
      "code": "dynamic.country.mac",
      "value": "Macao"
    },
    {
      "code": "dynamic.country.mcd",
      "value": "Macedonia"
    },
    {
      "code": "dynamic.country.mdg",
      "value": "Madagascar"
    },
    {
      "code": "dynamic.country.mwi",
      "value": "Malawi"
    },
    {
      "code": "dynamic.country.mys",
      "value": "Malaysia"
    },
    {
      "code": "dynamic.country.mdv",
      "value": "Maldives"
    },
    {
      "code": "dynamic.country.mli",
      "value": "Mali Republic"
    },
    {
      "code": "dynamic.country.mlt",
      "value": "Malta"
    },
    {
      "code": "dynamic.country.mhl",
      "value": "Marshall Islands"
    },
    {
      "code": "dynamic.country.mto",
      "value": "Martinique"
    },
    {
      "code": "dynamic.country.mrt",
      "value": "Mauritania"
    },
    {
      "code": "dynamic.country.mus",
      "value": "Mauritius"
    },
    {
      "code": "dynamic.country.myt",
      "value": "Mayotte Island"
    },
    {
      "code": "dynamic.country.fxx",
      "value": "Metropolitan France"
    },
    {
      "code": "dynamic.country.mex",
      "value": "Mexico"
    },
    {
      "code": "dynamic.country.fsm",
      "value": "Micronesia"
    },
    {
      "code": "dynamic.country.mda",
      "value": "Moldova"
    },
    {
      "code": "dynamic.country.mco",
      "value": "Monaco"
    },
    {
      "code": "dynamic.country.mng",
      "value": "Mongolian Peoples Republi"
    },
    {
      "code": "dynamic.country.mne",
      "value": "Montenegro"
    },
    {
      "code": "dynamic.country.msr",
      "value": "Montserrat"
    },
    {
      "code": "dynamic.country.mar",
      "value": "Morocco"
    },
    {
      "code": "dynamic.country.moz",
      "value": "Mozambique"
    },
    {
      "code": "dynamic.country.mmr",
      "value": "Myanmar"
    },
    {
      "code": "dynamic.country.nam",
      "value": "Namibia"
    },
    {
      "code": "dynamic.country.nru",
      "value": "Nauru"
    },
    {
      "code": "dynamic.country.npl",
      "value": "Nepal"
    },
    {
      "code": "dynamic.country.nld",
      "value": "Netherlands"
    },
    {
      "code": "dynamic.country.ant",
      "value": "Netherlands Antillesnes"
    },
    {
      "code": "dynamic.country.ncl",
      "value": "New Caledonia"
    },
    {
      "code": "dynamic.country.nzl",
      "value": "New Zealand"
    },
    {
      "code": "dynamic.country.nic",
      "value": "Nicaragua"
    },
    {
      "code": "dynamic.country.nga",
      "value": "Nigeria"
    },
    {
      "code": "dynamic.country.niu",
      "value": "Niue"
    },
    {
      "code": "dynamic.country.nfk",
      "value": "Norfolk Island"
    },
    {
      "code": "dynamic.country.prk",
      "value": "North Korea"
    },
    {
      "code": "dynamic.country.mnp",
      "value": "Northern Mariana Isl"
    },
    {
      "code": "dynamic.country.nor",
      "value": "Norway"
    },
    {
      "code": "dynamic.country.omn",
      "value": "Oman"
    },
    {
      "code": "dynamic.country.oth",
      "value": "Other"
    },
    {
      "code": "dynamic.country.pak",
      "value": "Pakistan"
    },
    {
      "code": "dynamic.country.plw",
      "value": "Palau"
    },
    {
      "code": "dynamic.country.pse",
      "value": "Palestine"
    },
    {
      "code": "dynamic.country.pan",
      "value": "Panama"
    },
    {
      "code": "dynamic.country.png",
      "value": "Papua New Guinea"
    },
    {
      "code": "dynamic.country.par",
      "value": "Paracel Islands"
    },
    {
      "code": "dynamic.country.pry",
      "value": "Paraguay"
    },
    {
      "code": "dynamic.country.per",
      "value": "Peru"
    },
    {
      "code": "dynamic.country.phl",
      "value": "Philippines"
    },
    {
      "code": "dynamic.country.pcn",
      "value": "Pitcairn Islands"
    },
    {
      "code": "dynamic.country.pol",
      "value": "Poland"
    },
    {
      "code": "dynamic.country.prt",
      "value": "Portugal"
    },
    {
      "code": "dynamic.country.pri",
      "value": "Puerto Rico"
    },
    {
      "code": "dynamic.country.qat",
      "value": "Qatar"
    },
    {
      "code": "dynamic.country.cog",
      "value": "Republic Of Congo"
    },
    {
      "code": "dynamic.country.ymd",
      "value": "Republic Of Yemen"
    },
    {
      "code": "dynamic.country.reu",
      "value": "Reunion Island"
    },
    {
      "code": "dynamic.country.rom",
      "value": "Romania"
    },
    {
      "code": "dynamic.country.rue",
      "value": "Russia"
    },
    {
      "code": "dynamic.country.rwa",
      "value": "Rwanda"
    },
    {
      "code": "dynamic.country.sgs",
      "value": "S.Georgia and s.Sandwich Isla"
    },
    {
      "code": "dynamic.country.shn",
      "value": "Saint Helena"
    },
    {
      "code": "dynamic.country.kna",
      "value": "Saint Kitts  and  Nevis"
    },
    {
      "code": "dynamic.country.lca",
      "value": "Saint Lucia"
    },
    {
      "code": "dynamic.country.spm",
      "value": "Saint Pierre  and  Miquelon"
    },
    {
      "code": "dynamic.country.wsm",
      "value": "Samoa  Western Ind"
    },
    {
      "code": "dynamic.country.smr",
      "value": "San Marino"
    },
    {
      "code": "dynamic.country.stp",
      "value": "Sao Tome And Principe"
    },
    {
      "code": "dynamic.country.sau",
      "value": "Saudi Arabia"
    },
    {
      "code": "dynamic.country.sen",
      "value": "Senegal Republic"
    },
    {
      "code": "dynamic.country.srb",
      "value": "Serbia"
    },
    {
      "code": "dynamic.country.syc",
      "value": "Seychelles Islands"
    },
    {
      "code": "dynamic.country.sle",
      "value": "Sierra Leone"
    },
    {
      "code": "dynamic.country.sgp",
      "value": "Singapore"
    },
    {
      "code": "dynamic.country.sxm",
      "value": "Sint Maarten"
    },
    {
      "code": "dynamic.country.svk",
      "value": "Slovakia"
    },
    {
      "code": "dynamic.country.svn",
      "value": "Slovenia"
    },
    {
      "code": "dynamic.country.slb",
      "value": "Solomon Islands"
    },
    {
      "code": "dynamic.country.som",
      "value": "Somalia"
    },
    {
      "code": "dynamic.country.zaf",
      "value": "South Africa"
    },
    {
      "code": "dynamic.country.kor",
      "value": "South Korea"
    },
    {
      "code": "dynamic.country.esp",
      "value": "Spain"
    },
    {
      "code": "dynamic.country.spr",
      "value": "Spratley Islands"
    },
    {
      "code": "dynamic.country.lka",
      "value": "Sri Lanka"
    },
    {
      "code": "dynamic.country.vct",
      "value": "St Vincent  and  Grenadines"
    },
    {
      "code": "dynamic.country.stk",
      "value": "St. Kitts"
    },
    {
      "code": "dynamic.country.stm",
      "value": "St. Maarten"
    },
    {
      "code": "dynamic.country.sdn",
      "value": "Sudan"
    },
    {
      "code": "dynamic.country.sur",
      "value": "Suriname"
    },
    {
      "code": "dynamic.country.sjm",
      "value": "Svalbard and jan Mayen I"
    },
    {
      "code": "dynamic.country.swz",
      "value": "Swaziland"
    },
    {
      "code": "dynamic.country.swe",
      "value": "Sweden"
    },
    {
      "code": "dynamic.country.che",
      "value": "Switzerland"
    },
    {
      "code": "dynamic.country.syr",
      "value": "Syrian Arab Republic"
    },
    {
      "code": "dynamic.country.twn",
      "value": "Taiwan"
    },
    {
      "code": "dynamic.country.tjk",
      "value": "Tajikistan"
    },
    {
      "code": "dynamic.country.tza",
      "value": "Tanzania"
    },
    {
      "code": "dynamic.country.tha",
      "value": "Thailand"
    },
    {
      "code": "dynamic.country.tgo",
      "value": "Togo"
    },
    {
      "code": "dynamic.country.tkl",
      "value": "Tokelau"
    },
    {
      "code": "dynamic.country.ton",
      "value": "Tonga Islands"
    },
    {
      "code": "dynamic.country.tto",
      "value": "Trinidad And Tobago"
    },
    {
      "code": "dynamic.country.tun",
      "value": "Tunisia"
    },
    {
      "code": "dynamic.country.tur",
      "value": "Turkey"
    },
    {
      "code": "dynamic.country.tkm",
      "value": "Turkmenistan"
    },
    {
      "code": "dynamic.country.tca",
      "value": "Turks And Caicos Island"
    },
    {
      "code": "dynamic.country.tuv",
      "value": "Tuvalu"
    },
    {
      "code": "dynamic.country.umi",
      "value": "U.S. Minor Out Islan"
    },
    {
      "code": "dynamic.country.uga",
      "value": "Uganda"
    },
    {
      "code": "dynamic.country.ukr",
      "value": "Ukraine"
    },
    {
      "code": "dynamic.country.are",
      "value": "United Arab Emirates"
    },
    {
      "code": "dynamic.country.gbr",
      "value": "United Kingdom"
    },
    {
      "code": "dynamic.country.usa",
      "value": "United States"
    },
    {
      "code": "dynamic.country.ury",
      "value": "Uruguay"
    },
    {
      "code": "dynamic.country.uzb",
      "value": "Uzbekistan"
    },
    {
      "code": "dynamic.country.vut",
      "value": "Vanuatu"
    },
    {
      "code": "dynamic.country.vat",
      "value": "Vatican City"
    },
    {
      "code": "dynamic.country.ven",
      "value": "Venezuela"
    },
    {
      "code": "dynamic.country.vnm",
      "value": "Vietnam"
    },
    {
      "code": "dynamic.country.vgb",
      "value": "Virgin Islands  British"
    },
    {
      "code": "dynamic.country.vir",
      "value": "Virgin Islands  U.S."
    },
    {
      "code": "dynamic.country.wlf",
      "value": "Wallis And Futuna Islands"
    },
    {
      "code": "dynamic.country.esh",
      "value": "Western Sahara"
    },
    {
      "code": "dynamic.country.yem",
      "value": "Yemen"
    },
    {
      "code": "dynamic.country.zar",
      "value": "Zaire"
    },
    {
      "code": "dynamic.country.zmb",
      "value": "Zambia"
    },
    {
      "code": "dynamic.country.zwe",
      "value": "Zimbabwe"
    },
    {
      "code": "label.language.selector",
      "value": "Choose a language"
    },
    {
      "code": "dynamic.gender.female",
      "value": "FEMALE"
    },
    {
      "code": "dynamic.gender.male",
      "value": "MALE"
    },
    {
      "code": "dynamic.title.rev",
      "value": "Reverend"
    },
    {
      "code": "dynamic.title.mr",
      "value": "Mr"
    },
    {
      "code": "dynamic.title.ms",
      "value": "Ms"
    },
    {
      "code": "dynamic.title.lady",
      "value": "Lady"
    },
    {
      "code": "dynamic.title.dr",
      "value": "Doctor"
    },
    {
      "code": "dynamic.title.mrs",
      "value": "Mrs"
    },
    {
      "code": "dynamic.title.gen",
      "value": "General"
    },
    {
      "code": "dynamic.title.lord",
      "value": "Lord"
    },
    {
      "code": "dynamic.title.mast",
      "value": "Master"
    },
    {
      "code": "dynamic.title.maj",
      "value": "Major"
    },
    {
      "code": "dynamic.title.miss",
      "value": "Miss"
    },
    {
      "code": "dynamic.title.adml",
      "value": "Admiral"
    },
    {
      "code": "dynamic.title.prof",
      "value": "Professor"
    },
    {
      "code": "dynamic.title.capt",
      "value": "Captain"
    },
    {
      "code": "dynamic.title.sir",
      "value": "Sir"
    },
    {
      "code": "dynamic.marital.status.single",
      "value": "Single"
    },
    {
      "code": "dynamic.marital.status.married",
      "value": "Married"
    },
    {
      "code": "dynamic.page.content.checking.alert",
      "value": "has already checked in. Any changes you make to the information below will require them to reprint their Xpress Pass."
    },
    {
      "code": "dynamic.page.content.olci.info",
      "value": "Please enter your name exactly as it appears on your immigration documentation"
    },
    {
      "code": "dynamic.urgent.contact.method.1",
      "value": "My Email Address"
    },
    {
      "code": "dynamic.urgent.contact.method.2",
      "value": "My Alternate Email Address"
    },
    {
      "code": "dynamic.urgent.contact.method.3",
      "value": "Call My Primary Phone Number"
    },
    {
      "code": "dynamic.urgent.contact.method.4",
      "value": "Call My Mobile Phone Number"
    },
    {
      "code": "dynamic.urgent.contact.method.5",
      "value": "Text My Mobile Phone Number"
    },
    {
      "code": "dynamic.language.en_us",
      "value": "English"
    },
    {
      "code": "dynamic.language.es_ca",
      "value": "Spanish"
    },
    {
      "code": "dynamic.language.pt_br",
      "value": "Portuguese"
    },
    {
      "code": "ssp.thank.you.for.completing.the.checkin.process",
      "value": "<meta charset=\"utf-8\" /><h2>THANK YOU FOR COMPLETING THE<span>&nbsp;</span><br />CHECK-IN PROCESS!</h2><p>Bring your&nbsp;Xpress Pass with you to the port. One of our agents will greet you at the pier and validate your documents for boarding.</p>"
    },
    {
      "code": "ssp.be.ready.for.your.arrival",
      "value": "<meta charset=\"utf-8\" /><h2>BE READY FOR YOUR ARRIVAL</h2><h3>GET ONBOARD FASTER WITH THE FOLLOWING REQUIRED DOCUMENTS.</h3><ol><li>Your&nbsp;Xpress Pass.</li><li>Valid passport.</li></ol><p>Please have your&nbsp;Xpress Pass and passport ready to show at your Check-In appointment. This will allow you to board the ship as quickly as possible. Ensure that the name on your passport matches the name used on your reservation. Failure to comply may result in delayed or denied boarding.</p>"
    },
    {
      "code": "ssp.printed.title",
      "value": "Printed"
    },
    {
      "code": "ssp.ctc.gov.regulations",
      "value": "Due to government regulations,  all guests are required to be at the pier and checked in no later than 90 minutes prior to sail time."
    },
    {
      "code": "ssp.online.checkin.title",
      "value": "CHECK-IN"
    },
    {
      "code": "button.okay",
      "value": "Okay"
    },
    {
      "code": "landing.page.title.checked.in.guests",
      "value": "Checked in and ready to sail"
    }
  ]
}
